import { jsxs as h, jsx as t, Fragment as ge } from "react/jsx-runtime";
import * as e from "react";
import { useState as B, useRef as k, useEffect as F, createContext as ot, forwardRef as R, useId as Y, useCallback as I, useLayoutEffect as at, useMemo as Lt, useContext as rt, useImperativeHandle as bn } from "react";
import { createPortal as bt } from "react-dom";
const fn = "AppShell-module__shell___sfjp5", vn = "AppShell-module__header___q88zN", $n = "AppShell-module__body___hv--l", An = "AppShell-module__left___sg1tG", En = "AppShell-module__right___1R1W7", Nn = "AppShell-module__sidebar___behPB", wn = "AppShell-module__main___NwE-A", Ie = {
  shell: fn,
  header: vn,
  body: $n,
  left: An,
  right: En,
  sidebar: Nn,
  main: wn
};
function V2({
  header: a,
  sidebar: n,
  sidebarPosition: l = "left",
  children: o,
  className: c
}) {
  return /* @__PURE__ */ h("div", { className: `${Ie.shell} ${c ?? ""}`, children: [
    a && /* @__PURE__ */ t("header", { className: Ie.header, children: a }),
    /* @__PURE__ */ h("div", { className: `${Ie.body} ${Ie[l]}`, children: [
      n && /* @__PURE__ */ t("aside", { className: Ie.sidebar, children: n }),
      /* @__PURE__ */ t("main", { className: Ie.main, children: o })
    ] })
  ] });
}
const yn = "ShellPanel-module__shellPanel___t0isC", Zn = "ShellPanel-module__content___vnBme", Mn = "ShellPanel-module__contentCollapsed___xNTnF", Ln = "ShellPanel-module__resizeHandle___psYKv", ct = {
  shellPanel: yn,
  content: Zn,
  contentCollapsed: Mn,
  resizeHandle: Ln
};
function xe(a) {
  return Math.floor(window.innerWidth * a / 100);
}
function P2({
  actionBar: a,
  children: n,
  collapsed: l = !1,
  defaultWidth: o = 320,
  defaultWidthVw: c,
  resizable: r = !1,
  onResize: s,
  minWidth: _ = 200,
  maxWidth: d = 800,
  minWidthVw: p,
  maxWidthVw: u,
  className: i
}) {
  const [g, w] = B(
    () => u ? xe(u) : d
  ), [$, Z] = B(
    () => p ? xe(p) : _
  ), [y, E] = B(o), H = k(!1), f = k(!1), v = k(0), m = k(0);
  F(() => {
    const N = c ? xe(c) : o, M = Math.min(g, Math.max($, N));
    M !== y && (H.current = !1, E(M));
  }, [o, c, g, $]), F(() => {
    if (!u && !p && !c)
      return;
    const N = () => {
      const M = u ? xe(u) : d, b = p ? xe(p) : _;
      w(M), Z(b), E((S) => {
        const T = !H.current && c ? xe(c) : S;
        return Math.min(M, Math.max(b, T));
      });
    };
    return window.addEventListener("resize", N), () => window.removeEventListener("resize", N);
  }, [u, p, c, d, _]), F(() => {
    if (!r)
      return;
    function N(b) {
      if (!f.current)
        return;
      const S = b.clientX - v.current, T = Math.min(
        g,
        Math.max($, m.current + S)
      );
      E(T), H.current = !0, s?.(T);
    }
    function M() {
      f.current = !1, document.body.style.cursor = "", document.body.style.userSelect = "";
    }
    return window.addEventListener("mousemove", N), window.addEventListener("mouseup", M), () => {
      window.removeEventListener("mousemove", N), window.removeEventListener("mouseup", M);
    };
  }, [r, $, g, s]);
  function A(N) {
    f.current = !0, v.current = N.clientX, m.current = y, document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }
  return /* @__PURE__ */ h("div", { className: `${ct.shellPanel} ${i ?? ""}`, children: [
    a,
    /* @__PURE__ */ t(
      "div",
      {
        className: `${ct.content} ${l ? ct.contentCollapsed : ""}`,
        style: { width: l ? 0 : y },
        "aria-hidden": l ? "true" : void 0,
        children: n
      }
    ),
    r && !l && /* @__PURE__ */ t(
      "div",
      {
        className: ct.resizeHandle,
        onMouseDown: A,
        "aria-hidden": "true"
      }
    )
  ] });
}
const Hn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H69l51.52,51.51a12,12,0,0,1-17,17l-72-72a12,12,0,0,1,0-17l72-72a12,12,0,0,1,17,17L69,116H216A12,12,0,0,1,228,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M112,56V200L40,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M216,120H120V56a8,8,0,0,0-13.66-5.66l-72,72a8,8,0,0,0,0,11.32l72,72A8,8,0,0,0,120,200V136h96a8,8,0,0,0,0-16ZM104,180.69,51.31,128,104,75.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H120v64a8,8,0,0,1-13.66,5.66l-72-72a8,8,0,0,1,0-11.32l72-72A8,8,0,0,1,120,56v64h96A8,8,0,0,1,224,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H54.49l61.75,61.76a6,6,0,1,1-8.48,8.48l-72-72a6,6,0,0,1,0-8.48l72-72a6,6,0,0,1,8.48,8.48L54.49,122H216A6,6,0,0,1,222,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H49.66l65.17,65.17a4,4,0,0,1-5.66,5.66l-72-72a4,4,0,0,1,0-5.66l72-72a4,4,0,0,1,5.66,5.66L49.66,124H216A4,4,0,0,1,220,128Z" }))
  ]
]), Cn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), Sn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M160,48V208L80,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z" }))
  ]
]), kn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), Tn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,160H48l80-80Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z" }))
  ]
]), In = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184.49,167.51a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17,0l-48-48a12,12,0,0,1,17-17L128,207l39.51-39.52A12,12,0,0,1,184.49,167.51Zm-96-79L128,49l39.51,39.52a12,12,0,0,0,17-17l-48-48a12,12,0,0,0-17,0l-48,48a12,12,0,0,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M80,176h96l-48,48ZM128,32,80,80h96Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Zm-48,44.69L99.31,184h57.38ZM80,88h96a8,8,0,0,0,5.66-13.66l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,80,88Zm48-44.69L156.69,72H99.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M72.61,83.06a8,8,0,0,1,1.73-8.72l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,176,88H80A8,8,0,0,1,72.61,83.06ZM176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M180.24,171.76a6,6,0,0,1,0,8.48l-48,48a6,6,0,0,1-8.48,0l-48-48a6,6,0,0,1,8.48-8.48L128,215.51l43.76-43.75A6,6,0,0,1,180.24,171.76Zm-96-87.52L128,40.49l43.76,43.75a6,6,0,0,0,8.48-8.48l-48-48a6,6,0,0,0-8.48,0l-48,48a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,170.34a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L128,212.69l42.34-42.35A8,8,0,0,1,181.66,170.34Zm-96-84.68L128,43.31l42.34,42.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,85.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.83,173.17a4,4,0,0,1,0,5.66l-48,48a4,4,0,0,1-5.66,0l-48-48a4,4,0,0,1,5.66-5.66L128,218.34l45.17-45.17A4,4,0,0,1,178.83,173.17Zm-96-90.34L128,37.66l45.17,45.17a4,4,0,1,0,5.66-5.66l-48-48a4,4,0,0,0-5.66,0l-48,48a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), xn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), Fn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), Bn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M196.49,151.51a12,12,0,0,1-17,17L168,157v51a12,12,0,0,1-24,0V157l-11.51,11.52a12,12,0,1,1-17-17l32-32a12,12,0,0,1,17,0ZM160,36A92.08,92.08,0,0,0,79,84.37,68,68,0,1,0,72,220h28a12,12,0,0,0,0-24H72a44,44,0,0,1-1.81-87.95A91.7,91.7,0,0,0,68,128a12,12,0,0,0,24,0,68,68,0,1,1,132.6,21.29,12,12,0,1,0,22.8,7.51A92.06,92.06,0,0,0,160,36Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M240,128a80,80,0,0,1-80,80H72A56,56,0,1,1,85.92,97.74l0,.1A80,80,0,0,1,240,128Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M178.34,165.66,160,147.31V208a8,8,0,0,1-16,0V147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32ZM160,40A88.08,88.08,0,0,0,81.29,88.68,64,64,0,1,0,72,216h40a8,8,0,0,0,0-16H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.12A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,100.8,66,8,8,0,0,0,3.2,15.34,7.9,7.9,0,0,0,3.2-.68A88,88,0,0,0,160,40Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M247.93,124.52C246.11,77.54,207.07,40,160.06,40A88.1,88.1,0,0,0,81.29,88.67h0A87.48,87.48,0,0,0,72,127.73,8.18,8.18,0,0,1,64.57,136,8,8,0,0,1,56,128a103.66,103.66,0,0,1,5.34-32.92,4,4,0,0,0-4.75-5.18A64.09,64.09,0,0,0,8,152c0,35.19,29.75,64,65,64H160A88.09,88.09,0,0,0,247.93,124.52Zm-50.27,9.14a8,8,0,0,1-11.32,0L168,115.31V176a8,8,0,0,1-16,0V115.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,197.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M188.24,164.24a6,6,0,0,1-8.48,0L158,142.49V208a6,6,0,0,1-12,0V142.49l-21.76,21.75a6,6,0,0,1-8.48-8.48l32-32a6,6,0,0,1,8.48,0l32,32A6,6,0,0,1,188.24,164.24ZM160,42A86.1,86.1,0,0,0,82.43,90.88,62,62,0,1,0,72,214h40a6,6,0,0,0,0-12H72a50,50,0,0,1,0-100,50.68,50.68,0,0,1,5.91.36A85.54,85.54,0,0,0,74,128a6,6,0,0,0,12,0,74,74,0,1,1,103.6,67.85,6,6,0,0,0,4.8,11A86,86,0,0,0,160,42Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.34,165.66,160,147.31V208a8,8,0,0,1-16,0V147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32ZM160,40A88.08,88.08,0,0,0,81.29,88.68,64,64,0,1,0,72,216h40a8,8,0,0,0,0-16H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.12A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,100.8,66,8,8,0,0,0,3.2,15.34,7.9,7.9,0,0,0,3.2-.68A88,88,0,0,0,160,40Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M186.83,162.83a4,4,0,0,1-5.66,0L156,137.66V208a4,4,0,0,1-8,0V137.66l-25.17,25.17a4,4,0,0,1-5.66-5.66l32-32a4,4,0,0,1,5.66,0l32,32A4,4,0,0,1,186.83,162.83ZM160,44A84.09,84.09,0,0,0,83.61,93.13,60,60,0,1,0,72,212h40a4,4,0,0,0,0-8H72a52,52,0,1,1,8.57-103.27A83.45,83.45,0,0,0,76,128a4,4,0,0,0,8,0,76,76,0,1,1,106.4,69.68,4,4,0,0,0,1.6,7.66,3.92,3.92,0,0,0,1.6-.33A84,84,0,0,0,160,44Z" }))
  ]
]), Dn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M108,60A16,16,0,1,1,92,44,16,16,0,0,1,108,60Zm56,16a16,16,0,1,0-16-16A16,16,0,0,0,164,76ZM92,112a16,16,0,1,0,16,16A16,16,0,0,0,92,112Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,112ZM92,180a16,16,0,1,0,16,16A16,16,0,0,0,92,180Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M208,32V224a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V32A16,16,0,0,1,64,16H192A16,16,0,0,1,208,32Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M192,16H64A16,16,0,0,0,48,32V224a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V32A16,16,0,0,0,192,16ZM100,200a12,12,0,1,1,12-12A12,12,0,0,1,100,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,80Zm56,120a12,12,0,1,1,12-12A12,12,0,0,1,156,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M102,60A10,10,0,1,1,92,50,10,10,0,0,1,102,60Zm62,10a10,10,0,1,0-10-10A10,10,0,0,0,164,70ZM92,118a10,10,0,1,0,10,10A10,10,0,0,0,92,118Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,118ZM92,186a10,10,0,1,0,10,10A10,10,0,0,0,92,186Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M100,60a8,8,0,1,1-8-8A8,8,0,0,1,100,60Zm64,8a8,8,0,1,0-8-8A8,8,0,0,0,164,68ZM92,120a8,8,0,1,0,8,8A8,8,0,0,0,92,120Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,120ZM92,188a8,8,0,1,0,8,8A8,8,0,0,0,92,188Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,188Z" }))
  ]
]), Rn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M114,145.34a12,12,0,0,0-20,0L79,167.82,72.3,157.73a12,12,0,0,0-20.07.17L13.91,217.51A12,12,0,0,0,24,236H152a12,12,0,0,0,10-18.66ZM46,212,62.5,186.3l6.55,9.81a12,12,0,0,0,20,0l15-22.48L129.58,212ZM216.49,79.51l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40v84a12,12,0,0,0,24,0V44h76V92a12,12,0,0,0,12,12h48V212a12,12,0,0,0,0,24h4a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.51ZM160,57l23,23H160Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M104,152l48,72H24l36-56,16.36,25.45ZM152,32V88h56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M110.66,147.56a8,8,0,0,0-13.32,0L76.49,178.85l-9.76-15.18a8,8,0,0,0-13.46,0l-36,56A8,8,0,0,0,24,232H152a8,8,0,0,0,6.66-12.44ZM38.65,216,60,182.79l9.63,15a8,8,0,0,0,13.39.11l21-31.47L137.05,216Zm175-133.66-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M158.66,219.56A8,8,0,0,1,152,232H24a8,8,0,0,1-6.73-12.33l36-56a8,8,0,0,1,13.46,0l9.76,15.18,20.85-31.29a8,8,0,0,1,13.32,0ZM216,88V216a16,16,0,0,1-16,16h-8a8,8,0,0,1,0-16h8V96H152a8,8,0,0,1-8-8V40H56v88a8,8,0,0,1-16,0V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88Zm-56-8h28.69L160,51.31Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M109,148.67a6,6,0,0,0-10,0L76.46,182.5,65.05,164.76a6,6,0,0,0-10.1,0l-36,56A6,6,0,0,0,24,230H152a6,6,0,0,0,5-9.33ZM35,218l25-38.9,11.32,17.6a6,6,0,0,0,10,.08l22.64-34L140.79,218ZM212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40v88a6,6,0,0,0,12,0V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216a2,2,0,0,1-2,2h-8a6,6,0,0,0,0,12h8a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M110.66,147.56a8,8,0,0,0-13.32,0L76.49,178.85l-9.76-15.18a8,8,0,0,0-13.46,0l-36,56A8,8,0,0,0,24,232H152a8,8,0,0,0,6.66-12.44ZM38.65,216,60,182.79l9.63,15a8,8,0,0,0,13.39.11l21-31.47L137.05,216Zm175-133.66-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M107.33,149.78a4,4,0,0,0-6.66,0L76.42,186.15,63.36,165.84a4,4,0,0,0-6.72,0l-36,56A4,4,0,0,0,24,228H152a4,4,0,0,0,3.33-6.22ZM31.33,220,60,175.4l13,20.22a4,4,0,0,0,3.33,1.83,3.93,3.93,0,0,0,3.36-1.78L104,159.21,144.53,220ZM210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40v88a4,4,0,0,0,8,0V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216a4,4,0,0,1-4,4h-8a4,4,0,0,0,0,8h8a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156Z" }))
  ]
]), Vn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), Pn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M87.5,151.52l64-64a12,12,0,0,1,17,17l-64,64a12,12,0,0,1-17-17Zm131-114a60.08,60.08,0,0,0-84.87,0L103.51,67.61a12,12,0,0,0,17,17l30.07-30.06a36,36,0,0,1,50.93,50.92L171.4,135.52a12,12,0,1,0,17,17l30.08-30.06A60.09,60.09,0,0,0,218.45,37.55ZM135.52,171.4l-30.07,30.08a36,36,0,0,1-50.92-50.93l30.06-30.07a12,12,0,0,0-17-17L37.55,133.58a60,60,0,0,0,84.88,84.87l30.06-30.07a12,12,0,0,0-17-17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M209.94,113.94l-96,96a48,48,0,0,1-67.88-67.88l96-96a48,48,0,0,1,67.88,67.88Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M165.66,90.34a8,8,0,0,1,0,11.32l-64,64a8,8,0,0,1-11.32-11.32l64-64A8,8,0,0,1,165.66,90.34ZM215.6,40.4a56,56,0,0,0-79.2,0L106.34,70.45a8,8,0,0,0,11.32,11.32l30.06-30a40,40,0,0,1,56.57,56.56l-30.07,30.06a8,8,0,0,0,11.31,11.32L215.6,119.6a56,56,0,0,0,0-79.2ZM138.34,174.22l-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM144.56,173.66l-21.45,21.45a44,44,0,0,1-62.22-62.22l21.45-21.46a8,8,0,0,1,11.32,11.31L72.2,144.2a28,28,0,0,0,39.6,39.6l21.45-21.46a8,8,0,0,1,11.31,11.32Zm-34.9-16a8,8,0,0,1-11.32-11.32l48-48a8,8,0,0,1,11.32,11.32Zm85.45-34.55-21.45,21.45a8,8,0,0,1-11.32-11.31L183.8,111.8a28,28,0,0,0-39.6-39.6L122.74,93.66a8,8,0,0,1-11.31-11.32l21.46-21.45a44,44,0,0,1,62.22,62.22Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M164.25,91.75a6,6,0,0,1,0,8.49l-64,64a6,6,0,0,1-8.49-8.48l64-64A6,6,0,0,1,164.25,91.75ZM214.2,41.8a54.07,54.07,0,0,0-76.38,0L107.75,71.85a6,6,0,0,0,8.49,8.49l30.07-30.06a42,42,0,0,1,59.41,59.41l-30.08,30.07a6,6,0,1,0,8.49,8.49l30.07-30.07A54,54,0,0,0,214.2,41.8ZM139.76,175.64l-30.07,30.08a42,42,0,0,1-59.41-59.41l30.06-30.07a6,6,0,0,0-8.49-8.49l-30,30.07a54,54,0,0,0,76.38,76.39l30.07-30.08a6,6,0,0,0-8.49-8.49Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M165.66,90.34a8,8,0,0,1,0,11.32l-64,64a8,8,0,0,1-11.32-11.32l64-64A8,8,0,0,1,165.66,90.34ZM215.6,40.4a56,56,0,0,0-79.2,0L106.34,70.45a8,8,0,0,0,11.32,11.32l30.06-30a40,40,0,0,1,56.57,56.56l-30.07,30.06a8,8,0,0,0,11.31,11.32L215.6,119.6a56,56,0,0,0,0-79.2ZM138.34,174.22l-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M162.84,93.16a4,4,0,0,1,0,5.66l-64,64a4,4,0,0,1-5.66-5.66l64-64A4,4,0,0,1,162.84,93.16Zm49.95-49.95a52.07,52.07,0,0,0-73.56,0L109.17,73.27a4,4,0,0,0,5.65,5.66l30.07-30.06a44,44,0,0,1,62.24,62.24l-30.07,30.06a4,4,0,0,0,5.66,5.66l30.07-30.06A52.07,52.07,0,0,0,212.79,43.21ZM141.17,177.06l-30.06,30.07a44,44,0,0,1-62.24-62.24l30.06-30.06a4,4,0,0,0-5.66-5.66L43.21,139.23a52,52,0,0,0,73.56,73.56l30.06-30.07a4,4,0,1,0-5.66-5.66Z" }))
  ]
]), zn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M76,64A12,12,0,0,1,88,52H216a12,12,0,0,1,0,24H88A12,12,0,0,1,76,64Zm140,52H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Zm0,64H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM44,112a16,16,0,1,0,16,16A16,16,0,0,0,44,112Zm0-64A16,16,0,1,0,60,64,16,16,0,0,0,44,48Zm0,128a16,16,0,1,0,16,16A16,16,0,0,0,44,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,64V192H88V64Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM68,188a12,12,0,1,1,12-12A12,12,0,0,1,68,188Zm0-48a12,12,0,1,1,12-12A12,12,0,0,1,68,140Zm0-48A12,12,0,1,1,80,80,12,12,0,0,1,68,92Zm124,92H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M82,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H88A6,6,0,0,1,82,64Zm134,58H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Zm0,64H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM44,54A10,10,0,1,0,54,64,10,10,0,0,0,44,54Zm0,128a10,10,0,1,0,10,10A10,10,0,0,0,44,182Zm0-64a10,10,0,1,0,10,10A10,10,0,0,0,44,118Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M84,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H88A4,4,0,0,1,84,64Zm132,60H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Zm0,64H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM44,120a8,8,0,1,0,8,8A8,8,0,0,0,44,120Zm0-64a8,8,0,1,0,8,8A8,8,0,0,0,44,56Zm0,128a8,8,0,1,0,8,8A8,8,0,0,0,44,184Z" }))
  ]
]), On = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H116a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM116,76H216a12,12,0,0,0,0-24H116a12,12,0,0,0,0,24ZM216,180H116a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM44,59.31V104a12,12,0,0,0,24,0V40A12,12,0,0,0,50.64,29.27l-16,8a12,12,0,0,0,9.36,22Zm39.73,96.86a27.7,27.7,0,0,0-11.2-18.63A28.89,28.89,0,0,0,32.9,143a27.71,27.71,0,0,0-4.17,7.54,12,12,0,0,0,22.55,8.21,4,4,0,0,1,.58-1,4.78,4.78,0,0,1,6.5-.82,3.82,3.82,0,0,1,1.61,2.6,3.63,3.63,0,0,1-.77,2.77l-.13.17L30.39,200.82A12,12,0,0,0,40,220H72a12,12,0,0,0,0-24H64l14.28-19.11A27.48,27.48,0,0,0,83.73,156.17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,64V192H104V64Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM56.84,75.58a8,8,0,0,1,3.58-10.74l16-8A8,8,0,0,1,88,64v48a8,8,0,0,1-16,0V76.94l-4.42,2.22A8,8,0,0,1,56.84,75.58ZM92,180a8,8,0,0,1,0,16H68a8,8,0,0,1-6.4-12.8l21.67-28.89A3.92,3.92,0,0,0,84,152a4,4,0,0,0-7.77-1.33,8,8,0,0,1-15.09-5.34,20,20,0,1,1,35,18.53L84,180Zm100,4H120a8,8,0,0,1,0-16h72a8,8,0,0,1,0,16Zm0-48H120a8,8,0,0,1,0-16h72a8,8,0,0,1,0,16Zm0-48H120a8,8,0,0,1,0-16h72a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H104a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM104,70H216a6,6,0,0,0,0-12H104a6,6,0,0,0,0,12ZM216,186H104a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM42.68,53.37,50,49.71V104a6,6,0,0,0,12,0V40a6,6,0,0,0-8.68-5.37l-16,8a6,6,0,0,0,5.36,10.74ZM72,202H52l21.48-28.74A21.5,21.5,0,0,0,77.79,157,21.75,21.75,0,0,0,69,142.38a22.86,22.86,0,0,0-31.35,4.31,22.18,22.18,0,0,0-3.28,5.92,6,6,0,0,0,11.28,4.11,9.87,9.87,0,0,1,1.48-2.67,10.78,10.78,0,0,1,14.78-2,9.89,9.89,0,0,1,4,6.61,9.64,9.64,0,0,1-2,7.28l-.06.09L35.2,204.41A6,6,0,0,0,40,214H72a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H104a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM104,68H216a4,4,0,0,0,0-8H104a4,4,0,0,0,0,8ZM216,188H104a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM41.79,51.58,52,46.47V104a4,4,0,0,0,8,0V40a4,4,0,0,0-5.79-3.58l-16,8a4,4,0,1,0,3.58,7.16ZM72,204H48l23.85-31.92a19.54,19.54,0,0,0,4-14.8,19.76,19.76,0,0,0-8-13.28,20.84,20.84,0,0,0-28.59,3.92,19.85,19.85,0,0,0-3,5.38A4,4,0,0,0,43.76,156a12.1,12.1,0,0,1,1.78-3.22,12.78,12.78,0,0,1,17.54-2.37,11.85,11.85,0,0,1,4.81,7.94,11.65,11.65,0,0,1-2.41,8.85L36.8,205.61A4,4,0,0,0,40,212H72a4,4,0,0,0,0-8Z" }))
  ]
]), Wn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,76H180V56A52,52,0,0,0,76,56V76H48A20,20,0,0,0,28,96V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V96A20,20,0,0,0,208,76ZM100,56a28,28,0,0,1,56,0V76H100ZM204,204H52V100H204Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M216,96V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208A8,8,0,0,1,216,96Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,82H174V56a46,46,0,0,0-92,0V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82ZM94,56a34,34,0,0,1,68,0V82H94ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,84H172V56a44,44,0,0,0-88,0V84H48A12,12,0,0,0,36,96V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V96A12,12,0,0,0,208,84ZM92,56a36,36,0,0,1,72,0V84H92ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }))
  ]
]), Gn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), Un = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M238.15,78.54,177.46,17.86a20,20,0,0,0-28.3,0L97.2,70c-12.43-3.33-36.68-5.72-61.74,14.5a20,20,0,0,0-1.6,29.73l45.46,45.47-39.8,39.8a12,12,0,0,0,17,17l39.8-39.81,45.47,45.46A20,20,0,0,0,155.91,228c.46,0,.93,0,1.4-.05A20,20,0,0,0,171.87,220c4.69-6.23,11-16.13,14.44-28s3.45-22.88.16-33.4l51.7-51.87A20,20,0,0,0,238.15,78.54Zm-74.26,68.79a12,12,0,0,0-2.23,13.84c3.43,6.86,6.9,21-6.28,40.65L54.08,100.53c21.09-14.59,39.53-6.64,41-6a11.67,11.67,0,0,0,13.81-2.29l54.43-54.61,55,55Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M229.66,98.34,172.39,155.8c11.46,22.93-1.72,45.86-10.11,57a8,8,0,0,1-12,.83L42.34,105.76A8,8,0,0,1,43,93.85c29.65-23.92,57.4-10,57.4-10l57.27-57.46a8,8,0,0,1,11.31,0L229.66,87A8,8,0,0,1,229.66,98.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M235.33,104l-53.47,53.65c4.56,12.67,6.45,33.89-13.19,60A15.93,15.93,0,0,1,157,224c-.38,0-.75,0-1.13,0a16,16,0,0,1-11.32-4.69L96.29,171,53.66,213.66a8,8,0,0,1-11.32-11.32L85,159.71l-48.3-48.3A16,16,0,0,1,38,87.63c25.42-20.51,49.75-16.48,60.4-13.14L152,20.7a16,16,0,0,1,22.63,0l60.69,60.68A16,16,0,0,1,235.33,104Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M233.91,82.79,173.22,22.1a14,14,0,0,0-19.81,0L98.93,76.77c-9.52-3.25-34-8.34-59.71,12.41A14,14,0,0,0,38.1,110l49.71,49.71-44.05,44a6,6,0,1,0,8.48,8.48l44.05-44.05L146,217.89a14,14,0,0,0,9.9,4.11q.49,0,1,0a14,14,0,0,0,10.19-5.54c19.72-26.21,17.15-47.23,12.46-59.3l54.37-54.55A14,14,0,0,0,233.91,82.79ZM225.42,94.1h0l-57.27,57.46a6,6,0,0,0-1.11,6.92c9.94,19.88-1.71,40.32-9.54,50.72a2,2,0,0,1-3,.2L46.58,101.51a2,2,0,0,1,.18-3c12.5-10.09,24.5-12.76,33.7-12.76a42.13,42.13,0,0,1,17.25,3.41A6,6,0,0,0,104.64,88L161.9,30.59a2,2,0,0,1,2.83,0l60.69,60.68A2,2,0,0,1,225.42,94.1Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,84.2,171.8,23.51a12,12,0,0,0-17,0L99.45,79.07c-8.08-3-32.79-9.45-59,11.67a12,12,0,0,0-1,17.84l51.13,51.13L45.17,205.17a4,4,0,0,0,5.66,5.66l45.46-45.47,51.12,51.12A12,12,0,0,0,155.9,220c.28,0,.57,0,.85,0a12,12,0,0,0,8.73-4.74c19.83-26.36,16.51-47.18,11.71-58.57l55.3-55.49A12,12,0,0,0,232.49,84.2Zm-5.66,11.31h0L169.56,153a4,4,0,0,0-.75,4.61c10.43,20.85-1.62,42-9.73,52.83a4,4,0,0,1-6,.4L45.17,102.93a4,4,0,0,1,.33-6C58.44,86.53,70.86,83.74,80.44,83.74A43.9,43.9,0,0,1,98.6,87.38a4,4,0,0,0,4.62-.75l57.27-57.46a4,4,0,0,1,5.66,0l60.68,60.69A4,4,0,0,1,226.83,95.51Z" }))
  ]
]), Yn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M185.08,114.46A48,48,0,0,0,148,36H80A12,12,0,0,0,68,48V200a12,12,0,0,0,12,12h80a52,52,0,0,0,25.08-97.54ZM92,60h56a24,24,0,0,1,0,48H92Zm68,128H92V132h68a28,28,0,0,1,0,56Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M200,160a40,40,0,0,1-40,40H80V48h68a36,36,0,0,1,0,72h12A40,40,0,0,1,200,160Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,156a20,20,0,0,1-20,20H96V136h52A20,20,0,0,1,168,156ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM184,156a36,36,0,0,0-18-31.15A36,36,0,0,0,140,64H88a8,8,0,0,0-8,8V184a8,8,0,0,0,8,8h60A36,36,0,0,0,184,156Zm-24-56a20,20,0,0,0-20-20H96v40h44A20,20,0,0,0,160,100Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M174.69,116.41A42,42,0,0,0,148,42H80a6,6,0,0,0-6,6V200a6,6,0,0,0,6,6h80a46,46,0,0,0,14.69-89.59ZM86,54h62a30,30,0,0,1,0,60H86Zm74,140H86V126h74a34,34,0,0,1,0,68Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M170.27,117.21A40,40,0,0,0,148,44H80a4,4,0,0,0-4,4V200a4,4,0,0,0,4,4h80a44,44,0,0,0,10.27-86.79ZM84,52h64a32,32,0,0,1,0,64H84Zm76,144H84V124h76a36,36,0,0,1,0,72Z" }))
  ]
]), Kn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204,56a12,12,0,0,1-12,12H160.65l-40,120H144a12,12,0,0,1,0,24H64a12,12,0,0,1,0-24H95.35l40-120H112a12,12,0,0,1,0-24h80A12,12,0,0,1,204,56Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M192,56,144,200H64L112,56Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM176,80H153.64l-34.29,96H136a8,8,0,0,1,0,16H80a8,8,0,0,1,0-16h22.36l34.29-96H120a8,8,0,0,1,0-16h56a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M198,56a6,6,0,0,1-6,6H156.32l-44,132H144a6,6,0,0,1,0,12H64a6,6,0,0,1,0-12H99.68l44-132H112a6,6,0,0,1,0-12h80A6,6,0,0,1,198,56Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M196,56a4,4,0,0,1-4,4H154.88L109.55,196H144a4,4,0,0,1,0,8H64a4,4,0,0,1,0-8h37.12L146.45,60H112a4,4,0,0,1,0-8h80A4,4,0,0,1,196,56Z" }))
  ]
]), Xn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204,224a12,12,0,0,1-12,12H64a12,12,0,0,1,0-24H192A12,12,0,0,1,204,224Zm-76-28a68.07,68.07,0,0,0,68-68V56a12,12,0,0,0-24,0v72a44,44,0,0,1-88,0V56a12,12,0,0,0-24,0v72A68.07,68.07,0,0,0,128,196Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184,56v80a56,56,0,0,1-112,0V56Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,72a8,8,0,0,1,16,0v48a32,32,0,0,0,64,0V72a8,8,0,0,1,16,0v48a48,48,0,0,1-96,0Zm96,128H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M198,224a6,6,0,0,1-6,6H64a6,6,0,0,1,0-12H192A6,6,0,0,1,198,224Zm-70-26a62.07,62.07,0,0,0,62-62V56a6,6,0,0,0-12,0v80a50,50,0,0,1-100,0V56a6,6,0,0,0-12,0v80A62.07,62.07,0,0,0,128,198Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M196,224a4,4,0,0,1-4,4H64a4,4,0,0,1,0-8H192A4,4,0,0,1,196,224Zm-68-28a60.07,60.07,0,0,0,60-60V56a4,4,0,0,0-8,0v80a52,52,0,0,1-104,0V56a4,4,0,0,0-8,0v80A60.07,60.07,0,0,0,128,196Z" }))
  ]
]), qn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]), jn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M116,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0ZM236,91.55v72.9a19.86,19.86,0,0,1-5.86,14.14l-51.55,51.55A19.85,19.85,0,0,1,164.45,236H91.55a19.85,19.85,0,0,1-14.14-5.86L25.86,178.59A19.86,19.86,0,0,1,20,164.45V91.55a19.86,19.86,0,0,1,5.86-14.14L77.41,25.86A19.85,19.85,0,0,1,91.55,20h72.9a19.85,19.85,0,0,1,14.14,5.86l51.55,51.55A19.86,19.86,0,0,1,236,91.55Zm-24,1.66L162.79,44H93.21L44,93.21v69.58L93.21,212h69.58L212,162.79ZM128,156a16,16,0,1,0,16,16A16,16,0,0,0,128,156Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M224,91.55v72.9a8,8,0,0,1-2.34,5.66l-51.55,51.55a8,8,0,0,1-5.66,2.34H91.55a8,8,0,0,1-5.66-2.34L34.34,170.11A8,8,0,0,1,32,164.45V91.55a8,8,0,0,1,2.34-5.66L85.89,34.34A8,8,0,0,1,91.55,32h72.9a8,8,0,0,1,5.66,2.34l51.55,51.55A8,8,0,0,1,224,91.55Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M122,136V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0ZM230,91.55v72.9a13.92,13.92,0,0,1-4.1,9.9L174.35,225.9a13.92,13.92,0,0,1-9.9,4.1H91.55a13.92,13.92,0,0,1-9.9-4.1L30.1,174.35a13.92,13.92,0,0,1-4.1-9.9V91.55a13.92,13.92,0,0,1,4.1-9.9L81.65,30.1a13.92,13.92,0,0,1,9.9-4.1h72.9a13.92,13.92,0,0,1,9.9,4.1L225.9,81.65A13.92,13.92,0,0,1,230,91.55Zm-12,0a2,2,0,0,0-.59-1.42L165.87,38.59a2,2,0,0,0-1.42-.59H91.55a2,2,0,0,0-1.41.59L38.58,90.13A2,2,0,0,0,38,91.55v72.9a2,2,0,0,0,.59,1.42l51.54,51.54a2,2,0,0,0,1.42.59h72.9a2,2,0,0,0,1.41-.59l51.56-51.54a2,2,0,0,0,.58-1.42ZM128,162a10,10,0,1,0,10,10A10,10,0,0,0,128,162Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M124,136V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0ZM228,91.55v72.9a12,12,0,0,1-3.51,8.49l-51.55,51.55a12,12,0,0,1-8.49,3.51H91.55a12,12,0,0,1-8.49-3.51L31.51,172.94A12,12,0,0,1,28,164.45V91.55a12,12,0,0,1,3.51-8.49L83.06,31.51A12,12,0,0,1,91.55,28h72.9a12,12,0,0,1,8.49,3.51l51.55,51.55A12,12,0,0,1,228,91.55Zm-8,0a4,4,0,0,0-1.17-2.83L167.28,37.17A4.06,4.06,0,0,0,164.45,36H91.55a4.06,4.06,0,0,0-2.83,1.17L37.17,88.72A4,4,0,0,0,36,91.55v72.9a4,4,0,0,0,1.17,2.83l51.55,51.55A4.06,4.06,0,0,0,91.55,220h72.9a4.06,4.06,0,0,0,2.83-1.17l51.55-51.55a4,4,0,0,0,1.17-2.83ZM128,164a8,8,0,1,0,8,8A8,8,0,0,0,128,164Z" }))
  ]
]), Jn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]), zt = ot({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), W = e.forwardRef(
  (a, n) => {
    const {
      alt: l,
      color: o,
      size: c,
      weight: r,
      mirrored: s,
      children: _,
      weights: d,
      ...p
    } = a, {
      color: u = "currentColor",
      size: i,
      weight: g = "regular",
      mirrored: w = !1,
      ...$
    } = e.useContext(zt);
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ref: n,
        xmlns: "http://www.w3.org/2000/svg",
        width: c ?? i,
        height: c ?? i,
        fill: o ?? u,
        viewBox: "0 0 256 256",
        transform: s || w ? "scale(-1, 1)" : void 0,
        ...$,
        ...p
      },
      !!l && /* @__PURE__ */ e.createElement("title", null, l),
      _,
      d.get(r ?? g)
    );
  }
);
W.displayName = "IconBase";
const ft = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Hn }));
ft.displayName = "ArrowLeftIcon";
const Ue = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Cn }));
Ue.displayName = "CaretDownIcon";
const It = Ue, Ht = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Sn }));
Ht.displayName = "CaretLeftIcon";
const Ct = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: kn }));
Ct.displayName = "CaretRightIcon";
const St = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Tn }));
St.displayName = "CaretUpIcon";
const Qn = St, Ot = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: In }));
Ot.displayName = "CaretUpDownIcon";
const Wt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: xn }));
Wt.displayName = "CheckIcon";
const Gt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Fn }));
Gt.displayName = "CheckCircleIcon";
const Ut = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Bn }));
Ut.displayName = "CloudArrowUpIcon";
const Yt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Dn }));
Yt.displayName = "DotsSixVerticalIcon";
const Kt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Rn }));
Kt.displayName = "FileImageIcon";
const Xt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Vn }));
Xt.displayName = "InfoIcon";
const qt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Pn }));
qt.displayName = "LinkSimpleIcon";
const jt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: zn }));
jt.displayName = "ListBulletsIcon";
const Jt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: On }));
Jt.displayName = "ListNumbersIcon";
const Qt = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Wn }));
Qt.displayName = "LockSimpleIcon";
const en = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Gn }));
en.displayName = "MagnifyingGlassIcon";
const tn = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Un }));
tn.displayName = "PushPinIcon";
const nn = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Yn }));
nn.displayName = "TextBIcon";
const an = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Kn }));
an.displayName = "TextItalicIcon";
const ln = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Xn }));
ln.displayName = "TextUnderlineIcon";
const on = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: qn }));
on.displayName = "WarningIcon";
const rn = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: jn }));
rn.displayName = "WarningOctagonIcon";
const de = e.forwardRef((a, n) => /* @__PURE__ */ e.createElement(W, { ref: n, ...a, weights: Jn }));
de.displayName = "XIcon";
const ea = "Panel-module__panel___ODFSU", ta = "Panel-module__header___Thenl", na = "Panel-module__headerStart___baSnW", aa = "Panel-module__heading___oiM9o", la = "Panel-module__headingGroup___TeqfT", oa = "Panel-module__headingPrefix___XB6nz", ra = "Panel-module__subtitle___hINzg", ca = "Panel-module__actions___ox3dn", sa = "Panel-module__back___-CSI4", ia = "Panel-module__close___K7NcX", da = "Panel-module__subHeader___No6o7", _a = "Panel-module__content___abEbs", ua = "Panel-module__contentFlush___1z4D7", ma = "Panel-module__footer___sp70h", ne = {
  panel: ea,
  header: ta,
  headerStart: na,
  heading: aa,
  headingGroup: la,
  headingPrefix: oa,
  subtitle: ra,
  actions: ca,
  back: sa,
  close: ia,
  subHeader: da,
  content: _a,
  contentFlush: ua,
  footer: ma
}, pa = R(
  ({
    heading: a,
    subtitle: n,
    headingPrefix: l,
    headerActions: o,
    subHeader: c,
    onBack: r,
    closable: s,
    onClose: _,
    flush: d,
    minimized: p,
    footer: u,
    children: i,
    className: g,
    style: w,
    ...$
  }, Z) => {
    const y = a || n || l || o || s || r, E = k(null), [H, f] = B(!1);
    return F(() => {
      if (d)
        return;
      const v = E.current;
      if (!v)
        return;
      const m = () => f(v.scrollHeight > v.clientHeight);
      m();
      const A = new ResizeObserver(m);
      return A.observe(v), () => A.disconnect();
    }, [d, i]), /* @__PURE__ */ h(
      "section",
      {
        ref: Z,
        "aria-label": typeof a == "string" ? a : void 0,
        className: `${ne.panel} ${g ?? ""}`,
        style: p ? { height: "auto", ...w } : w,
        ...$,
        children: [
          y && /* @__PURE__ */ h("header", { className: ne.header, children: [
            /* @__PURE__ */ h("div", { className: ne.headerStart, children: [
              r && /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": "Tilbake",
                  onClick: r,
                  className: ne.back,
                  children: /* @__PURE__ */ t(ft, { size: 16, weight: "bold" })
                }
              ),
              (a || n || l) && /* @__PURE__ */ h("div", { className: ne.headingGroup, children: [
                l && /* @__PURE__ */ t("div", { className: ne.headingPrefix, children: l }),
                a && /* @__PURE__ */ t("h2", { className: ne.heading, children: a }),
                n && /* @__PURE__ */ t("div", { className: ne.subtitle, children: n })
              ] })
            ] }),
            /* @__PURE__ */ h("div", { className: ne.actions, children: [
              o,
              s && /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": "Lukk",
                  onClick: _,
                  className: ne.close,
                  children: /* @__PURE__ */ t(de, { size: 16, weight: "bold" })
                }
              )
            ] })
          ] }),
          c && /* @__PURE__ */ t("div", { "data-panel-subheader": !0, className: ne.subHeader, children: c }),
          !p && /* @__PURE__ */ t(
            "div",
            {
              ref: E,
              className: d ? ne.contentFlush : ne.content,
              tabIndex: H ? 0 : void 0,
              children: i
            }
          ),
          u && /* @__PURE__ */ t("footer", { className: ne.footer, children: u })
        ]
      }
    );
  }
);
pa.displayName = "Panel";
const ha = "Block-module__block___QqcBU", ga = "Block-module__open___a8cTi", ba = "Block-module__trigger___GG43J", fa = "Block-module__heading___Tvwph", va = "Block-module__indicator___scr4v", $a = "Block-module__contentWrapper___Mv-rl", Aa = "Block-module__content___TtVra", Me = {
  block: ha,
  open: ga,
  trigger: ba,
  heading: fa,
  indicator: va,
  contentWrapper: $a,
  content: Aa
};
function z2({
  heading: a,
  defaultOpen: n = !1,
  children: l,
  className: o
}) {
  const r = `${Y()}-content`, [s, _] = B(n);
  return /* @__PURE__ */ h("section", { className: `${Me.block} ${s ? Me.open : ""} ${o ?? ""}`, children: [
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        "aria-expanded": s,
        "aria-controls": r,
        onClick: () => _(!s),
        className: Me.trigger,
        children: [
          /* @__PURE__ */ t("span", { className: Me.heading, children: a }),
          /* @__PURE__ */ t(Ue, { size: 16, weight: "bold", className: Me.indicator, "aria-hidden": "true" })
        ]
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        id: r,
        role: "region",
        className: Me.contentWrapper,
        children: /* @__PURE__ */ t("div", { className: Me.content, children: l })
      }
    )
  ] });
}
const Ea = "Accordion-module__accordion___FBCe9", Na = "Accordion-module__item___8o5k3", wa = "Accordion-module__open___EZa8M", ya = "Accordion-module__headingWrapper___V6IO5", Za = "Accordion-module__trigger___Yzl3t", Ma = "Accordion-module__headingText___yZokZ", La = "Accordion-module__heading___7sMz3", Ha = "Accordion-module__subtitle___uWd0g", Ca = "Accordion-module__actions___VF5zK", Sa = "Accordion-module__indicator___6Way3", ka = "Accordion-module__contentWrapper___sCCBw", Ta = "Accordion-module__content___3FnKx", se = {
  accordion: Ea,
  item: Na,
  open: wa,
  headingWrapper: ya,
  trigger: Za,
  headingText: Ma,
  heading: La,
  subtitle: Ha,
  actions: Ca,
  indicator: Sa,
  contentWrapper: ka,
  content: Ta
};
function O2({ items: a, multiple: n = !1, defaultOpenItems: l, className: o }) {
  const c = Y(), [r, s] = B(new Set(l)), _ = (d) => {
    s((p) => {
      const u = new Set(n ? p : []);
      return p.has(d) ? u.delete(d) : u.add(d), u;
    });
  };
  return /* @__PURE__ */ t("div", { className: `${se.accordion} ${o ?? ""}`, children: a.map((d) => {
    const p = r.has(d.id), u = `${c}-${d.id}-content`, i = `${c}-${d.id}-trigger`;
    return /* @__PURE__ */ h(
      "div",
      {
        className: `${se.item} ${p ? se.open : ""}`,
        children: [
          /* @__PURE__ */ h("h3", { className: se.headingWrapper, children: [
            /* @__PURE__ */ h(
              "button",
              {
                id: i,
                type: "button",
                "aria-expanded": p,
                "aria-controls": u,
                onClick: () => _(d.id),
                className: se.trigger,
                children: [
                  /* @__PURE__ */ h("span", { className: se.headingText, children: [
                    /* @__PURE__ */ t("span", { className: se.heading, children: d.heading }),
                    d.subtitle && /* @__PURE__ */ t("span", { className: se.subtitle, children: d.subtitle })
                  ] }),
                  /* @__PURE__ */ t(Ue, { size: 16, weight: "bold", className: se.indicator, "aria-hidden": "true" })
                ]
              }
            ),
            d.actions && /* @__PURE__ */ t("div", { className: se.actions, onClick: (g) => g.stopPropagation(), children: d.actions })
          ] }),
          /* @__PURE__ */ t(
            "div",
            {
              id: u,
              role: "region",
              "aria-labelledby": i,
              className: se.contentWrapper,
              children: /* @__PURE__ */ t("div", { className: se.content, children: d.content })
            }
          )
        ]
      },
      d.id
    );
  }) });
}
const Ia = "ActionBar-module__bar___nhW9w", xa = "ActionBar-module__horizontal___ZmKMM", Fa = "ActionBar-module__vertical___O06CR", Ba = "ActionBar-module__group___PsHBA", Nt = {
  bar: Ia,
  horizontal: xa,
  vertical: Fa,
  group: Ba
};
function W2({
  children: a,
  orientation: n = "horizontal",
  label: l,
  className: o
}) {
  return /* @__PURE__ */ t(
    "nav",
    {
      "aria-label": l,
      className: `${Nt.bar} ${Nt[n]} ${o ?? ""}`,
      children: a
    }
  );
}
function G2({ children: a, label: n, className: l }) {
  return /* @__PURE__ */ t(
    "div",
    {
      role: "group",
      "aria-label": n,
      className: `${Nt.group} ${l ?? ""}`,
      children: a
    }
  );
}
const Da = "BackButton-module__backButton___PNPrQ", Ra = "BackButton-module__iconSlot___9dXLc", Va = "BackButton-module__icon___SsDA7", Pa = "BackButton-module__label___ZHa5M", st = {
  backButton: Da,
  iconSlot: Ra,
  icon: Va,
  label: Pa
};
function U2({ children: a, className: n, ...l }) {
  const o = `${st.backButton} ${n ?? ""}`, c = /* @__PURE__ */ h(ge, { children: [
    /* @__PURE__ */ t("span", { className: st.iconSlot, "aria-hidden": "true", children: /* @__PURE__ */ t(Ht, { size: 16, weight: "bold", className: st.icon }) }),
    /* @__PURE__ */ t("span", { className: st.label, children: a })
  ] });
  return "href" in l && l.href !== void 0 ? /* @__PURE__ */ t("a", { className: o, ...l, children: c }) : /* @__PURE__ */ t("button", { type: "button", className: o, ...l, children: c });
}
const za = "FilterPanel-module__panel___UJqWy", Oa = "FilterPanel-module__fields___yXidK", Wa = "FilterPanel-module__footer___JnxH4", Ga = "FilterPanel-module__resetButton___cp37b", Ua = "FilterPanel-module__badge___einbe", Ye = {
  panel: za,
  fields: Oa,
  footer: Wa,
  resetButton: Ga,
  badge: Ua
};
function Y2({
  children: a,
  activeCount: n = 0,
  onReset: l,
  resetLabel: o = "Fjern alle filter",
  className: c
}) {
  const r = n > 0;
  return /* @__PURE__ */ h("div", { className: `${Ye.panel} ${c ?? ""}`, children: [
    /* @__PURE__ */ t("div", { className: Ye.fields, children: a }),
    r && l && /* @__PURE__ */ h("div", { className: Ye.footer, children: [
      /* @__PURE__ */ t("button", { type: "button", onClick: l, className: Ye.resetButton, children: o }),
      /* @__PURE__ */ t("span", { className: Ye.badge, "aria-label": `${n} aktive filter`, children: n })
    ] })
  ] });
}
const Ya = "TextInput-module__wrapper___2SrO0", Ka = "TextInput-module__label___MdN8i", Xa = "TextInput-module__inputWrapper___JQtT7", qa = "TextInput-module__input___0nWku", ja = "TextInput-module__sm___4HgOG", Ja = "TextInput-module__md___PGdmQ", Qa = "TextInput-module__lg___NZ581", el = "TextInput-module__prefix___D7LKA", tl = "TextInput-module__suffix___kuWce", nl = "TextInput-module__hasError___86XIp", al = "TextInput-module__error___dhh5d", ll = "TextInput-module__helperText___6k-Mj", j = {
  wrapper: Ya,
  label: Ka,
  inputWrapper: Xa,
  input: qa,
  sm: ja,
  md: Ja,
  lg: Qa,
  prefix: el,
  suffix: tl,
  hasError: nl,
  error: al,
  helperText: ll
}, kt = R(
  ({ label: a, helperText: n, error: l, prefix: o, suffix: c, size: r = "lg", hideLabel: s = !1, className: _, id: d, ...p }, u) => {
    const i = Y(), g = d ?? i, w = `${g}-helper`, $ = `${g}-error`, Z = k(null), y = u ?? Z, E = I(() => {
      y.current?.focus();
    }, [y]);
    return /* @__PURE__ */ h("div", { className: `${j.wrapper} ${j[r]} ${l ? j.hasError : ""} ${_ ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: g, className: `${j.label} ${s ? "sr-only" : ""}`, children: a }),
      /* @__PURE__ */ h("div", { className: j.inputWrapper, onClick: E, children: [
        o && /* @__PURE__ */ t("span", { className: j.prefix, children: o }),
        /* @__PURE__ */ t(
          "input",
          {
            ref: y,
            id: g,
            type: "text",
            "aria-describedby": l ? $ : n ? w : void 0,
            "aria-invalid": l ? !0 : void 0,
            className: j.input,
            ...p
          }
        ),
        c && /* @__PURE__ */ t("span", { className: j.suffix, children: c })
      ] }),
      l && /* @__PURE__ */ t("p", { id: $, className: j.error, role: "alert", children: l }),
      n && !l && /* @__PURE__ */ t("p", { id: w, className: j.helperText, children: n })
    ] });
  }
);
kt.displayName = "TextInput";
const ol = "SearchInput-module__clearButton___i1i4v", rl = {
  clearButton: ol
}, cl = R(
  ({
    label: a,
    value: n,
    onChange: l,
    onClear: o,
    placeholder: c = "Søk…",
    hideLabel: r = !1,
    size: s = "lg",
    autoFocus: _,
    className: d,
    autoComplete: p = "off"
  }, u) => {
    const i = (w) => {
      l(w.target.value);
    }, g = () => {
      o ? o() : l("");
    };
    return /* @__PURE__ */ t(
      kt,
      {
        ref: u,
        label: a,
        hideLabel: r,
        type: "text",
        value: n,
        onChange: i,
        placeholder: c,
        size: s,
        autoFocus: _,
        className: d,
        spellCheck: !1,
        autoComplete: p,
        prefix: /* @__PURE__ */ t(
          en,
          {
            size: s === "sm" ? 14 : 16,
            weight: "duotone",
            "aria-hidden": "true"
          }
        ),
        suffix: n.length > 0 ? /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            onClick: g,
            "aria-label": "Tøm søk",
            className: rl.clearButton,
            children: /* @__PURE__ */ t(
              de,
              {
                size: s === "sm" ? 12 : 14,
                "aria-hidden": "true"
              }
            )
          }
        ) : void 0
      }
    );
  }
);
cl.displayName = "SearchInput";
const sl = "NumberInput-module__wrapper___X3u87", il = "NumberInput-module__label___r4RW9", dl = "NumberInput-module__inputWrapper___mnbm8", _l = "NumberInput-module__sm___12wQu", ul = "NumberInput-module__md___kApTJ", ml = "NumberInput-module__lg___HnFuX", pl = "NumberInput-module__input___XO0Ym", hl = "NumberInput-module__prefix___e3gQ-", gl = "NumberInput-module__unit___Tio-N", bl = "NumberInput-module__hasError___UK5Yo", fl = "NumberInput-module__error___DXmBn", vl = "NumberInput-module__helperText___vvsC0", he = {
  wrapper: sl,
  label: il,
  inputWrapper: dl,
  sm: _l,
  md: ul,
  lg: ml,
  input: pl,
  prefix: hl,
  unit: gl,
  hasError: bl,
  error: fl,
  helperText: vl
}, $l = R(
  ({ label: a, helperText: n, error: l, unit: o, prefix: c, size: r = "lg", hideLabel: s = !1, className: _, id: d, ...p }, u) => {
    const i = Y(), g = d ?? i, w = `${g}-helper`, $ = `${g}-error`;
    return /* @__PURE__ */ h("div", { className: `${he.wrapper} ${he[r]} ${l ? he.hasError : ""} ${_ ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: g, className: `${he.label} ${s ? "sr-only" : ""}`, children: a }),
      /* @__PURE__ */ h("div", { className: he.inputWrapper, children: [
        c && /* @__PURE__ */ t("span", { className: he.prefix, "aria-hidden": "true", children: c }),
        /* @__PURE__ */ t(
          "input",
          {
            ref: u,
            id: g,
            type: "number",
            "aria-describedby": l ? $ : n ? w : void 0,
            "aria-invalid": l ? !0 : void 0,
            className: he.input,
            ...p
          }
        ),
        o && /* @__PURE__ */ t("span", { className: he.unit, "aria-hidden": "true", children: o })
      ] }),
      l && /* @__PURE__ */ t("p", { id: $, className: he.error, role: "alert", children: l }),
      n && !l && /* @__PURE__ */ t("p", { id: w, className: he.helperText, children: n })
    ] });
  }
);
$l.displayName = "NumberInput";
const Al = "TextArea-module__wrapper___8B55y", El = "TextArea-module__label___lzSBE", Nl = "TextArea-module__textarea___wIdGy", wl = "TextArea-module__hasError___d1Kqf", yl = "TextArea-module__error___m477-", Zl = "TextArea-module__helperText___SJrpF", Le = {
  wrapper: Al,
  label: El,
  textarea: Nl,
  hasError: wl,
  error: yl,
  helperText: Zl
}, Ml = R(
  ({ label: a, helperText: n, helperTextPosition: l = "below", error: o, hideLabel: c = !1, className: r, id: s, ..._ }, d) => {
    const p = Y(), u = s ?? p, i = `${u}-helper`, g = `${u}-error`;
    return /* @__PURE__ */ h("div", { className: `${Le.wrapper} ${o ? Le.hasError : ""} ${r ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: u, className: `${Le.label} ${c ? "sr-only" : ""}`, children: a }),
      l === "above" && n && !o && /* @__PURE__ */ t("p", { id: i, className: Le.helperText, children: n }),
      /* @__PURE__ */ t(
        "textarea",
        {
          ref: d,
          id: u,
          "aria-describedby": o ? g : n ? i : void 0,
          "aria-invalid": o ? !0 : void 0,
          className: Le.textarea,
          ..._
        }
      ),
      o && /* @__PURE__ */ t("p", { id: g, className: Le.error, role: "alert", children: o }),
      l === "below" && n && !o && /* @__PURE__ */ t("p", { id: i, className: Le.helperText, children: n })
    ] });
  }
);
Ml.displayName = "TextArea";
const Ll = R(
  ({ label: a, helperText: n, error: l, size: o = "lg", hideLabel: c = !1, className: r, id: s, ..._ }, d) => {
    const p = Y(), u = s ?? p, i = `${u}-helper`, g = `${u}-error`;
    return /* @__PURE__ */ h("div", { className: `${j.wrapper} ${j[o]} ${l ? j.hasError : ""} ${r ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: u, className: `${j.label} ${c ? "sr-only" : ""}`, children: a }),
      /* @__PURE__ */ t("div", { className: j.inputWrapper, children: /* @__PURE__ */ t(
        "input",
        {
          ref: d,
          id: u,
          type: "date",
          "aria-describedby": l ? g : n ? i : void 0,
          "aria-invalid": l ? !0 : void 0,
          className: j.input,
          ..._
        }
      ) }),
      l && /* @__PURE__ */ t("p", { id: g, className: j.error, role: "alert", children: l }),
      n && !l && /* @__PURE__ */ t("p", { id: i, className: j.helperText, children: n })
    ] });
  }
);
Ll.displayName = "DateInput";
const Hl = "Select-module__wrapper___Hr3x4", Cl = "Select-module__label___afWH7", Sl = "Select-module__select___iBXFK", kl = "Select-module__sm___XCymK", Tl = "Select-module__md___rmkbv", Il = "Select-module__lg___T0fSD", xl = "Select-module__hasError___QhkGe", Fl = "Select-module__error___P7VMK", Bl = "Select-module__helperText___t7Bvu", He = {
  wrapper: Hl,
  label: Cl,
  select: Sl,
  sm: kl,
  md: Tl,
  lg: Il,
  hasError: xl,
  error: Fl,
  helperText: Bl
};
function Dl(a) {
  return "options" in a;
}
const Rl = R(
  ({ label: a, options: n, placeholder: l, helperText: o, error: c, size: r = "lg", hideLabel: s = !1, className: _, id: d, ...p }, u) => {
    const i = Y(), g = d ?? i, w = `${g}-helper`, $ = `${g}-error`;
    return /* @__PURE__ */ h("div", { className: `${He.wrapper} ${He[r]} ${c ? He.hasError : ""} ${_ ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: g, className: `${He.label} ${s ? "sr-only" : ""}`, children: a }),
      /* @__PURE__ */ h(
        "select",
        {
          ref: u,
          id: g,
          "aria-describedby": c ? $ : o ? w : void 0,
          "aria-invalid": c ? !0 : void 0,
          className: He.select,
          ...p,
          children: [
            l && /* @__PURE__ */ t("option", { value: "", disabled: !0, children: l }),
            n.map(
              (Z) => Dl(Z) ? /* @__PURE__ */ t("optgroup", { label: Z.label, children: Z.options.map((y) => /* @__PURE__ */ t("option", { value: y.value, disabled: y.disabled, children: y.label }, y.value)) }, Z.label) : /* @__PURE__ */ t("option", { value: Z.value, disabled: Z.disabled, children: Z.label }, Z.value)
            )
          ]
        }
      ),
      c && /* @__PURE__ */ t("p", { id: $, className: He.error, role: "alert", children: c }),
      o && !c && /* @__PURE__ */ t("p", { id: w, className: He.helperText, children: o })
    ] });
  }
);
Rl.displayName = "Select";
const Vl = "Combobox-module__wrapper___dCKez", Pl = "Combobox-module__label___gVBKv", zl = "Combobox-module__inputContainer___YWHw9", Ol = "Combobox-module__sm___SdhIF", Wl = "Combobox-module__md___QBwW-", Gl = "Combobox-module__lg___xxAMI", Ul = "Combobox-module__inputScroll___u4rwJ", Yl = "Combobox-module__chip___opBY8", Kl = "Combobox-module__chipRemove___d3h-W", Xl = "Combobox-module__input___VscwS", ql = "Combobox-module__actions___ZnAY8", jl = "Combobox-module__actionBtn___u1TaG", Jl = "Combobox-module__chevron___Jw3IR", Ql = "Combobox-module__chevronOpen___ZSs-4", e0 = "Combobox-module__portalListbox___LBS0M", t0 = "Combobox-module__portalListboxGrid___GXIja", n0 = "Combobox-module__optionGrid___h6XnC", a0 = "Combobox-module__option___MN0kX", l0 = "Combobox-module__active___jNw-2", o0 = "Combobox-module__optionCheckbox___MqySp", r0 = "Combobox-module__optionCheckboxChecked___SoiJl", c0 = "Combobox-module__optionLabel___G2gGz", s0 = "Combobox-module__selected___iULBn", i0 = "Combobox-module__empty___v6wmo", d0 = "Combobox-module__hasError___ZxC2n", _0 = "Combobox-module__error___EXB46", O = {
  wrapper: Vl,
  label: Pl,
  inputContainer: zl,
  sm: Ol,
  md: Wl,
  lg: Gl,
  inputScroll: Ul,
  chip: Yl,
  chipRemove: Kl,
  input: Xl,
  actions: ql,
  actionBtn: jl,
  chevron: Jl,
  chevronOpen: Ql,
  portalListbox: e0,
  portalListboxGrid: t0,
  optionGrid: n0,
  option: a0,
  active: l0,
  optionCheckbox: o0,
  optionCheckboxChecked: r0,
  optionLabel: c0,
  selected: s0,
  empty: i0,
  hasError: d0,
  error: _0
}, u0 = R(
  ({
    label: a,
    options: n,
    value: l = [],
    onChange: o,
    placeholder: c = "Søk…",
    multiple: r = !1,
    disabled: s = !1,
    error: _,
    size: d = "lg",
    hideLabel: p = !1,
    className: u,
    renderOption: i,
    optionsLayout: g = "list"
  }, w) => {
    const $ = Y(), Z = `${$}-input`, y = `${$}-listbox`, E = `${$}-error`, H = k(null), f = k(null), v = k(null), [m, A] = B(!1), [N, M] = B(""), [b, S] = B(-1), [T, D] = B({ top: 0, left: 0, width: 0 }), V = n.filter(
      (L) => L.label.toLowerCase().includes(N.toLowerCase())
    ), te = (L) => l.includes(L), le = I(
      (L) => {
        o && (r ? o(
          te(L) ? l.filter((P) => P !== L) : [...l, L]
        ) : (o([L]), A(!1), M("")));
      },
      [r, o, l]
    ), _e = (L) => {
      switch (L.key) {
        case "ArrowDown":
          L.preventDefault(), A(!0), S((P) => Math.min(P + 1, V.length - 1));
          break;
        case "ArrowUp":
          L.preventDefault(), S((P) => Math.max(P - 1, 0));
          break;
        case "Enter":
          L.preventDefault(), b >= 0 && V[b] && le(V[b].value);
          break;
        case "Escape":
          m && (L.preventDefault(), L.stopPropagation()), A(!1), M(""), H.current?.focus();
          break;
        case "Home":
          m && (L.preventDefault(), S(0));
          break;
        case "End":
          m && (L.preventDefault(), S(V.length - 1));
          break;
      }
    };
    F(() => {
      m || S(-1);
    }, [m]), F(() => {
      b >= 0 && f.current && f.current.children[b]?.scrollIntoView({ block: "nearest" });
    }, [b]);
    const K = I(() => {
      const L = v.current;
      if (!L)
        return;
      const P = L.getBoundingClientRect(), J = 4, me = f.current?.getBoundingClientRect().height ?? 0;
      let Ae = P.bottom + J;
      me && Ae + me > window.innerHeight - 8 && (Ae = P.top - me - J), D({ top: Ae, left: P.left, width: P.width });
    }, []);
    at(() => {
      m && K();
    }, [m, V.length, K]), F(() => {
      if (m)
        return window.addEventListener("scroll", K, !0), window.addEventListener("resize", K), () => {
          window.removeEventListener("scroll", K, !0), window.removeEventListener("resize", K);
        };
    }, [m, K]);
    const ue = n.filter((L) => l.includes(L.value)), x = l.length > 0, C = !r && x && !N ? ue[0]?.label ?? "" : N;
    return /* @__PURE__ */ h(
      "div",
      {
        ref: w,
        className: `${O.wrapper} ${_ ? O.hasError : ""} ${u ?? ""}`,
        onBlur: (L) => {
          L.currentTarget.contains(L.relatedTarget) || (A(!1), M(""));
        },
        children: [
          /* @__PURE__ */ t("label", { id: `${$}-label`, htmlFor: Z, className: `${O.label} ${p ? "sr-only" : ""}`, children: a }),
          /* @__PURE__ */ h("div", { ref: v, className: `${O.inputContainer} ${O[d]}`, children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: O.inputScroll,
                onClick: () => H.current?.focus(),
                children: [
                  r && ue.map((L) => /* @__PURE__ */ h("span", { className: O.chip, children: [
                    L.label,
                    /* @__PURE__ */ t(
                      "button",
                      {
                        type: "button",
                        "aria-label": `Fjern ${L.label}`,
                        onClick: (P) => {
                          P.stopPropagation(), le(L.value);
                        },
                        className: O.chipRemove,
                        children: /* @__PURE__ */ t(de, { size: 10, weight: "bold" })
                      }
                    )
                  ] }, L.value)),
                  /* @__PURE__ */ t(
                    "input",
                    {
                      ref: H,
                      id: Z,
                      type: "text",
                      role: "combobox",
                      "aria-expanded": !!m,
                      "aria-controls": y,
                      "aria-activedescendant": b >= 0 ? `${$}-option-${b}` : void 0,
                      "aria-describedby": _ ? E : void 0,
                      "aria-invalid": !!_,
                      "aria-autocomplete": "list",
                      disabled: s,
                      placeholder: ue.length > 0 ? "" : c,
                      value: C,
                      onChange: (L) => {
                        M(L.target.value), A(!0), S(-1);
                      },
                      onFocus: () => A(!0),
                      onKeyDown: _e,
                      className: O.input
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ h("div", { className: O.actions, children: [
              x && /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": "Tøm valg",
                  className: O.actionBtn,
                  onMouseDown: (L) => L.preventDefault(),
                  onClick: () => {
                    o?.([]), M(""), H.current?.focus();
                  },
                  children: /* @__PURE__ */ t(de, { size: 14 })
                }
              ),
              /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": m ? "Lukk" : "Åpne",
                  className: O.actionBtn,
                  onMouseDown: (L) => L.preventDefault(),
                  onClick: () => {
                    A((L) => !L), H.current?.focus();
                  },
                  children: /* @__PURE__ */ t(
                    Ue,
                    {
                      size: 14,
                      className: `${O.chevron} ${m ? O.chevronOpen : ""}`
                    }
                  )
                }
              )
            ] })
          ] }),
          m && V.length > 0 && bt(
            /* @__PURE__ */ t(
              "ul",
              {
                ref: f,
                id: y,
                role: "listbox",
                "aria-labelledby": `${$}-label`,
                "aria-multiselectable": !!r,
                className: `${O.portalListbox} ${g === "grid" ? O.portalListboxGrid : ""}`,
                style: { top: T.top, left: T.left, width: T.width },
                children: V.map((L, P) => /* @__PURE__ */ h(
                  "li",
                  {
                    id: `${$}-option-${P}`,
                    role: "option",
                    "aria-selected": !!te(L.value),
                    "aria-label": L.label,
                    "data-active": P === b ? !0 : void 0,
                    className: `${O.option} ${g === "grid" ? O.optionGrid : ""} ${P === b ? O.active : ""} ${te(L.value) ? O.selected : ""}`,
                    onMouseDown: (J) => J.preventDefault(),
                    onClick: () => le(L.value),
                    children: [
                      r && /* @__PURE__ */ t(
                        "span",
                        {
                          className: `${O.optionCheckbox} ${te(L.value) ? O.optionCheckboxChecked : ""}`,
                          "aria-hidden": "true",
                          children: te(L.value) && /* @__PURE__ */ t(Wt, { size: 10, weight: "bold", color: "white" })
                        }
                      ),
                      /* @__PURE__ */ t("span", { className: O.optionLabel, children: i ? i(L) : L.label })
                    ]
                  },
                  L.value
                ))
              }
            ),
            // Inne i en modal <dialog> (showModal → top layer) ville en portal
            // til document.body havne bak dialogen uansett z-index.
            v.current?.closest("dialog") ?? document.body
          ),
          m && V.length === 0 && N && /* @__PURE__ */ t("div", { className: O.empty, role: "status", children: "Ingen treff" }),
          _ && /* @__PURE__ */ t("p", { id: E, className: O.error, role: "alert", children: _ })
        ]
      }
    );
  }
);
u0.displayName = "Combobox";
const m0 = "Checkbox-module__wrapper___Rab3a", p0 = "Checkbox-module__input___UY57E", h0 = "Checkbox-module__label___zy1Ey", $t = {
  wrapper: m0,
  input: p0,
  label: h0
}, wt = R(
  ({ label: a, hideLabel: n = !1, className: l, id: o, ...c }, r) => {
    const s = Y(), _ = o ?? s;
    return /* @__PURE__ */ h("div", { className: `${$t.wrapper} ${l ?? ""}`, children: [
      /* @__PURE__ */ t(
        "input",
        {
          ref: r,
          id: _,
          type: "checkbox",
          className: $t.input,
          ...c
        }
      ),
      /* @__PURE__ */ t("label", { htmlFor: _, className: `${$t.label} ${n ? "sr-only" : ""}`, children: a })
    ] });
  }
);
wt.displayName = "Checkbox";
const g0 = "RadioGroup-module__fieldset___B3fOl", b0 = "RadioGroup-module__legend___BSBF7", f0 = "RadioGroup-module__options___C1BxM", v0 = "RadioGroup-module__option___Ms3u2", $0 = "RadioGroup-module__input___IZFnD", A0 = "RadioGroup-module__label___4R6wX", Fe = {
  fieldset: g0,
  legend: b0,
  options: f0,
  option: v0,
  input: $0,
  label: A0
}, E0 = R(
  ({ legend: a, name: n, options: l, value: o, onChange: c, disabled: r, className: s, hideLabel: _ = !1 }, d) => {
    const p = Y();
    return /* @__PURE__ */ h(
      "fieldset",
      {
        ref: d,
        className: `${Fe.fieldset} ${s ?? ""}`,
        disabled: r,
        children: [
          /* @__PURE__ */ t("legend", { className: `${Fe.legend} ${_ ? "sr-only" : ""}`, children: a }),
          /* @__PURE__ */ t("div", { className: Fe.options, role: "radiogroup", children: l.map((u) => {
            const i = `${p}-${u.value}`;
            return /* @__PURE__ */ h("div", { className: Fe.option, children: [
              /* @__PURE__ */ t(
                "input",
                {
                  id: i,
                  type: "radio",
                  name: n,
                  value: u.value,
                  checked: o === u.value,
                  disabled: u.disabled,
                  onChange: () => c?.(u.value),
                  className: Fe.input
                }
              ),
              /* @__PURE__ */ t("label", { htmlFor: i, className: Fe.label, children: u.label })
            ] }, u.value);
          }) })
        ]
      }
    );
  }
);
E0.displayName = "RadioGroup";
const N0 = "SelectableCardGroup-module__fieldset___MNJgp", w0 = "SelectableCardGroup-module__legend___qblqP", y0 = "SelectableCardGroup-module__options___lHDXR", Z0 = "SelectableCardGroup-module__optionsRow___JwlNm", it = {
  fieldset: N0,
  legend: w0,
  options: y0,
  optionsRow: Z0
}, cn = ot(null);
function M0() {
  const a = rt(cn);
  if (!a)
    throw new Error("SelectableCard må brukes inne i en <SelectableCardGroup>.");
  return a;
}
function K2(a) {
  const {
    legend: n,
    hideLegend: l = !1,
    density: o = "card",
    name: c,
    disabled: r = !1,
    className: s,
    children: _
  } = a, d = Y(), p = Y(), u = c ?? d, i = a.mode, g = a.mode === "single" ? a.value : void 0, w = a.mode === "multiple" ? a.values : void 0, $ = a.mode === "single" ? a.onChange : void 0, Z = a.mode === "multiple" ? a.onChange : void 0, y = Lt(
    () => ({
      name: u,
      mode: i,
      density: o,
      groupDisabled: r,
      isSelected: (E) => i === "single" ? g === E : (w ?? []).includes(E),
      toggle: (E) => {
        if (i === "single")
          $?.(E);
        else {
          const H = w ?? [], f = H.includes(E) ? H.filter((v) => v !== E) : [...H, E];
          Z?.(f);
        }
      }
    }),
    [u, i, o, r, g, w, $, Z]
  );
  return /* @__PURE__ */ t(
    cn.Provider,
    {
      value: y,
      children: /* @__PURE__ */ h("fieldset", { className: `${it.fieldset} ${s ?? ""}`, disabled: r, children: [
        /* @__PURE__ */ t("legend", { id: p, className: `${it.legend} ${l ? "sr-only" : ""}`, children: n }),
        /* @__PURE__ */ t(
          "div",
          {
            className: `${it.options} ${o === "row" ? it.optionsRow : ""}`,
            ...a.mode === "single" ? { role: "radiogroup", "aria-labelledby": p } : {},
            children: _
          }
        )
      ] })
    }
  );
}
const L0 = "SelectableCard-module__card___qAPRl", H0 = "SelectableCard-module__input___VuI7M", C0 = "SelectableCard-module__content___M-54b", S0 = "SelectableCard-module__titleRow___5Ge3u", k0 = "SelectableCard-module__title___E7nw0", T0 = "SelectableCard-module__trailing___3nsH0", I0 = "SelectableCard-module__icon___9h0bR", x0 = "SelectableCard-module__description___RNuiG", F0 = "SelectableCard-module__row___MLyXy", B0 = "SelectableCard-module__selected___khT-7", D0 = "SelectableCard-module__disabled___1htuo", pe = {
  card: L0,
  input: H0,
  content: C0,
  titleRow: S0,
  title: k0,
  trailing: T0,
  icon: I0,
  description: x0,
  row: F0,
  selected: B0,
  disabled: D0
};
function X2({
  value: a,
  title: n,
  description: l,
  icon: o,
  trailing: c,
  disabled: r = !1,
  className: s
}) {
  const { name: _, mode: d, density: p, groupDisabled: u, isSelected: i, toggle: g } = M0(), w = i(a), $ = u || r, Z = d === "single" ? "radio" : "checkbox", y = [
    pe.card,
    p === "row" ? pe.row : "",
    w ? pe.selected : "",
    $ ? pe.disabled : "",
    s ?? ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ h("label", { className: y, children: [
    /* @__PURE__ */ t(
      "input",
      {
        type: Z,
        name: _,
        value: a,
        checked: w,
        disabled: $,
        onChange: () => g(a),
        className: pe.input
      }
    ),
    o && /* @__PURE__ */ t("span", { className: pe.icon, "aria-hidden": "true", children: o }),
    /* @__PURE__ */ h("span", { className: pe.content, children: [
      /* @__PURE__ */ h("span", { className: pe.titleRow, children: [
        /* @__PURE__ */ t("span", { className: pe.title, children: n }),
        c && /* @__PURE__ */ t("span", { className: pe.trailing, children: c })
      ] }),
      l && p !== "row" && /* @__PURE__ */ t("span", { className: pe.description, children: l })
    ] })
  ] });
}
const R0 = "Switch-module__wrapper___Wq6YJ", V0 = "Switch-module__labelRight___zk9Dl", P0 = "Switch-module__label___-glsZ", z0 = "Switch-module__track___m8M7P", O0 = "Switch-module__checked___TsD6-", W0 = "Switch-module__thumb___BdDG3", Be = {
  wrapper: R0,
  labelRight: V0,
  label: P0,
  track: z0,
  checked: O0,
  thumb: W0
}, G0 = R(
  ({ label: a, checked: n = !1, onChange: l, labelPosition: o = "left", hideLabel: c = !1, className: r, id: s, ..._ }, d) => {
    const p = Y(), u = s ?? p, i = `${u}-label`;
    return /* @__PURE__ */ h(
      "div",
      {
        className: `${Be.wrapper} ${o === "right" ? Be.labelRight : ""} ${r ?? ""}`,
        children: [
          /* @__PURE__ */ t("span", { id: i, className: `${Be.label} ${c ? "sr-only" : ""}`, children: a }),
          /* @__PURE__ */ t(
            "button",
            {
              ref: d,
              id: u,
              type: "button",
              role: "switch",
              "aria-checked": n,
              "aria-labelledby": i,
              onClick: () => l?.(!n),
              className: `${Be.track} ${n ? Be.checked : ""}`,
              ..._,
              children: /* @__PURE__ */ t("span", { className: Be.thumb })
            }
          )
        ]
      }
    );
  }
);
G0.displayName = "Switch";
const U0 = "Button-module__button___NBna4", Y0 = "Button-module__fullWidth___VILF3", K0 = "Button-module__primary___wgTQe", X0 = "Button-module__secondary___1OPQ8", q0 = "Button-module__danger___Bj02I", j0 = "Button-module__ghost___HDitR", J0 = "Button-module__icon___5I2sM", Q0 = "Button-module__sm___6dWkT", e1 = "Button-module__md___6y4KI", t1 = "Button-module__lg___Dod57", De = {
  button: U0,
  fullWidth: Y0,
  primary: K0,
  secondary: X0,
  danger: q0,
  ghost: j0,
  icon: J0,
  sm: Q0,
  md: e1,
  lg: t1
}, yt = R(
  (a, n) => {
    const { variant: l = "primary", size: o = "lg", fullWidth: c, leftIcon: r, rightIcon: s, className: _, children: d } = a, p = `${De.button} ${De[l]} ${De[o]} ${c ? De.fullWidth : ""} ${_ ?? ""}`, u = /* @__PURE__ */ h(ge, { children: [
      r && /* @__PURE__ */ t("span", { className: De.icon, "aria-hidden": "true", children: r }),
      d,
      s && /* @__PURE__ */ t("span", { className: De.icon, "aria-hidden": "true", children: s })
    ] });
    if (a.href !== void 0) {
      const { variant: f, size: v, fullWidth: m, leftIcon: A, rightIcon: N, children: M, className: b, ...S } = a;
      return /* @__PURE__ */ t(
        "a",
        {
          ref: n,
          className: p,
          ...S,
          children: u
        }
      );
    }
    const { variant: i, size: g, fullWidth: w, leftIcon: $, rightIcon: Z, children: y, className: E, ...H } = a;
    return /* @__PURE__ */ t(
      "button",
      {
        ref: n,
        className: p,
        ...H,
        children: u
      }
    );
  }
);
yt.displayName = "Button";
const n1 = "IconButton-module__iconButton___rcotx", a1 = "IconButton-module__outline___SHAi3", l1 = "IconButton-module__primary___AOPfb", o1 = "IconButton-module__ghost___bAJCX", r1 = "IconButton-module__active___yo22T", c1 = "IconButton-module__icon___0giCS", s1 = "IconButton-module__sm___BpECH", i1 = "IconButton-module__md___QdYIR", d1 = "IconButton-module__lg___--jJP", Ke = {
  iconButton: n1,
  outline: a1,
  primary: l1,
  ghost: o1,
  active: r1,
  icon: c1,
  sm: s1,
  md: i1,
  lg: d1
}, sn = R(
  ({ icon: a, label: n, size: l = "md", variant: o = "ghost", active: c = !1, type: r = "button", className: s, ..._ }, d) => /* @__PURE__ */ t(
    "button",
    {
      ref: d,
      type: r,
      "aria-label": n,
      "aria-pressed": c,
      className: `${Ke.iconButton} ${Ke[l]} ${Ke[o]} ${c ? Ke.active : ""} ${s ?? ""}`,
      ..._,
      children: /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Ke.icon, children: a })
    }
  )
);
sn.displayName = "IconButton";
const _1 = "SegmentedControl-module__group___xArOi", u1 = "SegmentedControl-module__full___mnNC8", m1 = "SegmentedControl-module__auto___GfhCW", p1 = "SegmentedControl-module__item___aMNsd", h1 = "SegmentedControl-module__md___pnX6X", g1 = "SegmentedControl-module__lg___JxDiU", b1 = "SegmentedControl-module__selected___cQMVK", Xe = {
  group: _1,
  full: u1,
  auto: m1,
  item: p1,
  md: h1,
  lg: g1,
  selected: b1
};
function q2({
  label: a,
  options: n,
  value: l,
  onChange: o,
  size: c = "md",
  width: r = "full",
  className: s
}) {
  const _ = Y(), d = k(null);
  return /* @__PURE__ */ t(
    "div",
    {
      ref: d,
      role: "radiogroup",
      "aria-label": a,
      onKeyDown: (u) => {
        if (u.key !== "ArrowLeft" && u.key !== "ArrowRight")
          return;
        u.preventDefault();
        const i = n.findIndex((Z) => Z.value === l), g = u.key === "ArrowRight" ? (i + 1) % n.length : (i - 1 + n.length) % n.length;
        o(n[g].value);
        const w = `${_}-${n[g].value}`;
        d.current?.querySelector(
          `#${CSS.escape(w)}`
        )?.focus();
      },
      className: `${Xe.group} ${Xe[c]} ${Xe[r]} ${s ?? ""}`,
      children: n.map((u) => {
        const i = u.value === l, g = `${_}-${u.value}`;
        return /* @__PURE__ */ t(
          "button",
          {
            id: g,
            type: "button",
            role: "radio",
            "aria-checked": i,
            tabIndex: i ? 0 : -1,
            onClick: () => o(u.value),
            className: `${Xe.item} ${i ? Xe.selected : ""}`,
            children: u.label
          },
          u.value
        );
      })
    }
  );
}
const f1 = "TabBar-module__tabBar___9j197", v1 = "TabBar-module__tab___ULbVO", $1 = "TabBar-module__tabCompact___PpF64", A1 = "TabBar-module__tabActive___ZCxrQ", E1 = "TabBar-module__tabCount___F2hQu", qe = {
  tabBar: f1,
  tab: v1,
  tabCompact: $1,
  tabActive: A1,
  tabCount: E1
};
function j2({ tabs: a, activeTab: n, onTabChange: l, size: o = "md", className: c }) {
  return /* @__PURE__ */ t(
    "div",
    {
      role: "tablist",
      className: `${qe.tabBar} ${c ?? ""}`,
      children: a.map((r) => {
        const s = r.id === n;
        return /* @__PURE__ */ h(
          "button",
          {
            role: "tab",
            type: "button",
            "aria-selected": s,
            "aria-controls": r.panelId,
            id: `tab-${r.id}`,
            className: `${qe.tab} ${o === "sm" ? qe.tabCompact : ""} ${s ? qe.tabActive : ""}`,
            onClick: () => l(r.id),
            children: [
              r.label,
              r.count !== void 0 && /* @__PURE__ */ t("span", { className: qe.tabCount, children: r.count })
            ]
          },
          r.id
        );
      })
    }
  );
}
const N1 = "Toolbar-module__toolbar___V0G3O", w1 = "Toolbar-module__vertical___C4JTT", y1 = "Toolbar-module__group___yhmD2", Z1 = "Toolbar-module__groupVertical___HKCJp", M1 = "Toolbar-module__divider___D32Zh", L1 = "Toolbar-module__dividerVertical___4L-M6", Ge = {
  toolbar: N1,
  vertical: w1,
  group: y1,
  groupVertical: Z1,
  divider: M1,
  dividerVertical: L1
}, H1 = {
  weight: "duotone",
  color: "var(--accent-default)"
};
function J2({ children: a, id: n, className: l, "aria-label": o, orientation: c = "horizontal" }) {
  return /* @__PURE__ */ t(
    "div",
    {
      id: n,
      className: `${Ge.toolbar} ${c === "vertical" ? Ge.vertical : ""} ${l ?? ""}`,
      role: "toolbar",
      "aria-orientation": c,
      "aria-label": o,
      children: /* @__PURE__ */ t(zt.Provider, { value: H1, children: a })
    }
  );
}
function Q2({ children: a, orientation: n = "horizontal" }) {
  return /* @__PURE__ */ t("div", { className: `${Ge.group} ${n === "vertical" ? Ge.groupVertical : ""}`, children: a });
}
function e_({ orientation: a = "horizontal" }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: `${Ge.divider} ${a === "vertical" ? Ge.dividerVertical : ""}`,
      role: "separator"
    }
  );
}
const C1 = "ToolbarItem-module__item___jxryp", S1 = "ToolbarItem-module__sm___Dxmlv", k1 = "ToolbarItem-module__md___rBrp9", T1 = "ToolbarItem-module__lg___tLMtl", I1 = "ToolbarItem-module__withLabel___bOrRQ", x1 = "ToolbarItem-module__icon___MRu-m", F1 = "ToolbarItem-module__label___NxUJg", B1 = "ToolbarItem-module__active___EfGMG", Re = {
  item: C1,
  sm: S1,
  md: k1,
  lg: T1,
  withLabel: I1,
  icon: x1,
  label: F1,
  active: B1
}, D1 = R(
  ({ icon: a, label: n, showLabel: l = !1, size: o = "md", active: c = !1, type: r = "button", className: s, ..._ }, d) => /* @__PURE__ */ h(
    "button",
    {
      ref: d,
      type: r,
      "aria-label": n,
      "aria-pressed": c,
      className: `${Re.item} ${Re[o]} ${l ? Re.withLabel : ""} ${c ? Re.active : ""} ${s ?? ""}`,
      ..._,
      children: [
        /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Re.icon, children: a }),
        l && /* @__PURE__ */ t("span", { className: Re.label, children: n })
      ]
    }
  )
);
D1.displayName = "ToolbarItem";
const R1 = "List-module__list___-17QG", V1 = "List-module__item___pIboR", P1 = "List-module__selected___R1Q88", z1 = "List-module__disabled___rOmQW", O1 = "List-module__prefix___lpAke", W1 = "List-module__content___5yska", G1 = "List-module__label___W5T5i", U1 = "List-module__description___dUiir", Y1 = "List-module__suffix___Cb0gH", $e = {
  list: R1,
  item: V1,
  selected: P1,
  disabled: z1,
  prefix: O1,
  content: W1,
  label: G1,
  description: U1,
  suffix: Y1
}, K1 = R(
  ({ label: a, children: n, className: l, ...o }, c) => /* @__PURE__ */ t(
    "ul",
    {
      ref: c,
      role: "list",
      "aria-label": a,
      className: `${$e.list} ${l ?? ""}`,
      ...o,
      children: n
    }
  )
);
K1.displayName = "List";
const X1 = R(
  ({ children: a, description: n, prefix: l, suffix: o, selected: c, disabled: r, className: s, ..._ }, d) => /* @__PURE__ */ h(
    "li",
    {
      ref: d,
      "aria-current": c ? !0 : void 0,
      "aria-disabled": r,
      className: `${$e.item} ${c ? $e.selected : ""} ${r ? $e.disabled : ""} ${s ?? ""}`,
      ..._,
      children: [
        l && /* @__PURE__ */ t("span", { className: $e.prefix, children: l }),
        /* @__PURE__ */ h("div", { className: $e.content, children: [
          /* @__PURE__ */ t("span", { className: $e.label, children: a }),
          n && /* @__PURE__ */ t("span", { className: $e.description, children: n })
        ] }),
        o && /* @__PURE__ */ t("span", { className: $e.suffix, children: o })
      ]
    }
  )
);
X1.displayName = "ListItem";
const q1 = "ListItem-module__listItem___7ikaS", j1 = "ListItem-module__interactive___7Gp-p", J1 = "ListItem-module__active___6OVUe", Q1 = "ListItem-module__leading___FDU7N", eo = "ListItem-module__content___KuDKd", to = "ListItem-module__trailing___jCqHd", Ve = {
  listItem: q1,
  interactive: j1,
  active: J1,
  leading: Q1,
  content: eo,
  trailing: to
}, no = R(({ leading: a, children: n, trailing: l, onClick: o, onDoubleClick: c, active: r, className: s }, _) => {
  const d = [
    Ve.listItem,
    o || c ? Ve.interactive : "",
    r ? Ve.active : "",
    s ?? ""
  ].filter(Boolean).join(" "), p = /* @__PURE__ */ h(ge, { children: [
    a && /* @__PURE__ */ t("span", { className: Ve.leading, children: a }),
    /* @__PURE__ */ t("span", { className: Ve.content, children: n }),
    l && /* @__PURE__ */ t("span", { className: Ve.trailing, children: l })
  ] });
  return o || c ? /* @__PURE__ */ t(
    "button",
    {
      ref: _,
      type: "button",
      className: d,
      onClick: o,
      onDoubleClick: c,
      children: p
    }
  ) : /* @__PURE__ */ t("div", { ref: _, className: d, children: p });
});
no.displayName = "ListItem";
const ao = "Card-module__card___QitiT", lo = "Card-module__header___e9Tsk", oo = "Card-module__content___ZtA7i", ro = "Card-module__footer___QGrH2", vt = {
  card: ao,
  header: lo,
  content: oo,
  footer: ro
}, co = R(
  ({ children: a, className: n, ...l }, o) => /* @__PURE__ */ t(
    "article",
    {
      ref: o,
      className: `${vt.card} ${n ?? ""}`,
      ...l,
      children: a
    }
  )
);
co.displayName = "Card";
function t_({ children: a, className: n }) {
  return /* @__PURE__ */ t("header", { className: `${vt.header} ${n ?? ""}`, children: a });
}
function n_({ children: a, className: n }) {
  return /* @__PURE__ */ t("div", { className: `${vt.content} ${n ?? ""}`, children: a });
}
function a_({ children: a, className: n }) {
  return /* @__PURE__ */ t("footer", { className: `${vt.footer} ${n ?? ""}`, children: a });
}
const so = "ListCard-module__card___QPe8e", io = "ListCard-module__prefix___bx-8s", _o = "ListCard-module__body___7BKHb", uo = "ListCard-module__bodyAlignStart___lRIIP", mo = "ListCard-module__content___BcWzS", po = "ListCard-module__title___jActg", ho = "ListCard-module__titleMonospace___8-yGu", go = "ListCard-module__description___ZINkM", bo = "ListCard-module__action___3clMo", fo = "ListCard-module__titleButton___3IDrw", vo = "ListCard-module__clickable___JzT-y", $o = "ListCard-module__selected___KiDyI", ie = {
  card: so,
  prefix: io,
  body: _o,
  bodyAlignStart: uo,
  content: mo,
  title: po,
  titleMonospace: ho,
  description: go,
  action: bo,
  titleButton: fo,
  clickable: vo,
  selected: $o
};
function l_({ title: a, titleMonospace: n, description: l, prefix: o, prefixAlign: c = "center", action: r, className: s, selected: _, onClick: d, onMouseEnter: p, onMouseLeave: u }) {
  const i = `${ie.title} ${n ? ie.titleMonospace : ""}`, g = d ? /* @__PURE__ */ t("button", { type: "button", className: ie.titleButton, onClick: d, children: /* @__PURE__ */ t("span", { className: i, children: a }) }) : /* @__PURE__ */ t("span", { className: i, children: a }), w = /* @__PURE__ */ h("div", { className: ie.content, children: [
    g,
    l && /* @__PURE__ */ t("span", { className: ie.description, children: l })
  ] });
  return /* @__PURE__ */ h(
    "article",
    {
      className: `${ie.card} ${d ? ie.clickable : ""} ${_ ? ie.selected : ""} ${s ?? ""}`,
      onMouseEnter: p,
      onMouseLeave: u,
      children: [
        o ? /* @__PURE__ */ h("div", { className: `${ie.body} ${c === "start" ? ie.bodyAlignStart : ""}`, children: [
          /* @__PURE__ */ t("div", { className: ie.prefix, children: o }),
          w
        ] }) : w,
        r && /* @__PURE__ */ t("div", { className: ie.action, children: r })
      ]
    }
  );
}
const Ao = "SearchResultCard-module__card___-Gka3", Eo = "SearchResultCard-module__stretchedButton___ac2HD", No = "SearchResultCard-module__focused___mgOpO", wo = "SearchResultCard-module__content___l9043", yo = "SearchResultCard-module__title___-jEqv", Zo = "SearchResultCard-module__meta___dMKES", Mo = "SearchResultCard-module__subtitle___nifkp", Lo = "SearchResultCard-module__status___YVonv", Ho = "SearchResultCard-module__secondaryAction___mNoGn", fe = {
  card: Ao,
  stretchedButton: Eo,
  focused: No,
  content: wo,
  title: yo,
  meta: Zo,
  subtitle: Mo,
  status: Lo,
  secondaryAction: Ho
}, Co = R(
  ({
    title: a,
    subtitle: n,
    status: l,
    secondaryAction: o,
    onClick: c,
    onMouseEnter: r,
    onMouseLeave: s,
    onFocus: _,
    onBlur: d,
    isFocused: p,
    className: u
  }, i) => {
    const g = !!l || !!n;
    return /* @__PURE__ */ h(
      "article",
      {
        ref: i,
        className: [fe.card, p ? fe.focused : "", u ?? ""].filter(Boolean).join(" "),
        onMouseEnter: r,
        onMouseLeave: s,
        children: [
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: fe.stretchedButton,
              onClick: c,
              onFocus: _,
              onBlur: d,
              "aria-label": a
            }
          ),
          /* @__PURE__ */ h("div", { className: fe.content, children: [
            /* @__PURE__ */ t("span", { className: fe.title, children: a }),
            g && /* @__PURE__ */ h("div", { className: fe.meta, children: [
              l && /* @__PURE__ */ t("div", { className: fe.status, children: l }),
              n && /* @__PURE__ */ t("span", { className: fe.subtitle, children: n })
            ] })
          ] }),
          o && /* @__PURE__ */ t("div", { className: fe.secondaryAction, children: o })
        ]
      }
    );
  }
);
Co.displayName = "SearchResultCard";
const So = "Chip-module__chip___uxY-c", ko = "Chip-module__info___gt8SM", To = "Chip-module__success___5-5sd", Io = "Chip-module__warning___F19BQ", xo = "Chip-module__danger___-Gjoy", Fo = "Chip-module__onbrand___tvCkD", Bo = "Chip-module__icon___Z-eSE", Do = "Chip-module__label___JFLFr", Ro = "Chip-module__remove___ZkCbH", je = {
  chip: So,
  default: "Chip-module__default___Dinv4",
  info: ko,
  success: To,
  warning: Io,
  danger: xo,
  onbrand: Fo,
  icon: Bo,
  label: Do,
  remove: Ro
}, Vo = R(
  ({
    children: a,
    variant: n = "default",
    icon: l,
    onRemove: o,
    removeLabel: c = "Fjern",
    className: r,
    ...s
  }, _) => /* @__PURE__ */ h(
    "span",
    {
      ref: _,
      className: `${je.chip} ${je[n]} ${r ?? ""}`,
      ...s,
      children: [
        l && /* @__PURE__ */ t("span", { className: je.icon, "aria-hidden": "true", children: l }),
        /* @__PURE__ */ t("span", { className: je.label, children: a }),
        o && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": `${c} ${typeof a == "string" ? a : ""}`,
            onClick: o,
            className: je.remove,
            children: /* @__PURE__ */ t(de, { size: 12, weight: "bold" })
          }
        )
      ]
    }
  )
);
Vo.displayName = "Chip";
const Po = "FilterChipGroup-module__filterRow___mmL6n", zo = "FilterChipGroup-module__filterChip___QngEB", Oo = "FilterChipGroup-module__filterChipActive___gFTcz", Wo = "FilterChipGroup-module__filterChipCount___PPTC-", dt = {
  filterRow: Po,
  filterChip: zo,
  filterChipActive: Oo,
  filterChipCount: Wo
}, Go = R(
  ({ label: a, options: n, value: l, onChange: o, className: c }, r) => /* @__PURE__ */ t(
    "div",
    {
      ref: r,
      role: "radiogroup",
      "aria-label": a,
      className: `${dt.filterRow} ${c ?? ""}`,
      children: n.map((s) => {
        const _ = s.value === l;
        return /* @__PURE__ */ h(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": _,
            className: `${dt.filterChip} ${_ ? dt.filterChipActive : ""}`,
            onClick: () => o(s.value),
            children: [
              s.label,
              s.count !== void 0 && /* @__PURE__ */ t("span", { className: dt.filterChipCount, "aria-hidden": "true", children: s.count })
            ]
          },
          s.value
        );
      })
    }
  )
);
Go.displayName = "FilterChipGroup";
const Uo = "Avatar-module__avatar___G2xrz", Yo = "Avatar-module__sm___HCOUV", Ko = "Avatar-module__md___dHepW", Xo = "Avatar-module__lg___ouZDr", qo = "Avatar-module__image___UMWuG", jo = "Avatar-module__initials___cPOmk", _t = {
  avatar: Uo,
  sm: Yo,
  md: Ko,
  lg: Xo,
  image: qo,
  initials: jo
}, Jo = { sm: 28, md: 36, lg: 48 };
function Qo({ src: a, alt: n, initials: l, size: o = "md", className: c }) {
  const r = Jo[o];
  return /* @__PURE__ */ t(
    "span",
    {
      className: `${_t.avatar} ${_t[o]} ${c ?? ""}`,
      role: "img",
      "aria-label": n,
      children: a ? /* @__PURE__ */ t("img", { src: a, alt: "", width: r, height: r, className: _t.image }) : /* @__PURE__ */ t("span", { className: _t.initials, "aria-hidden": "true", children: l ?? n.charAt(0).toUpperCase() })
    }
  );
}
const er = "StatusDot-module__dot___WknV2", tr = "StatusDot-module__sm___t8o2u", nr = "StatusDot-module__md___aJwIq", ar = "StatusDot-module__error___lyt1X", lr = "StatusDot-module__warning___P2rsU", or = "StatusDot-module__success___VWkra", rr = "StatusDot-module__info___jNXYJ", At = {
  dot: er,
  sm: tr,
  md: nr,
  error: ar,
  warning: lr,
  success: or,
  info: rr
};
function o_({
  variant: a,
  label: n,
  size: l = "sm",
  children: o,
  className: c
}) {
  return /* @__PURE__ */ t(
    "span",
    {
      className: `${At.dot} ${At[l]} ${At[a]} ${c ?? ""}`,
      role: n ? "img" : void 0,
      "aria-label": n,
      children: l === "md" ? o : null
    }
  );
}
const cr = "Table-module__scroll___5RcC3", sr = "Table-module__table___Zk0Qo", ir = "Table-module__layoutFixed___-em-r", dr = "Table-module__head___KWk3X", _r = "Table-module__th___U8BvP", ur = "Table-module__sortButton___GyPcH", mr = "Table-module__sortIcon___ITFh1", pr = "Table-module__sortIconIdle___vYObA", hr = "Table-module__row___eDxYw", gr = "Table-module__striped___kTqGn", br = "Table-module__selected___H0JPu", fr = "Table-module__interactive___8znT8", vr = "Table-module__alignLeft___DoJnb", $r = "Table-module__alignRight___u1OFt", Ar = "Table-module__alignCenter___fblc3", ee = {
  scroll: cr,
  table: sr,
  layoutFixed: ir,
  head: dr,
  th: _r,
  sortButton: ur,
  sortIcon: mr,
  sortIconIdle: pr,
  row: hr,
  striped: gr,
  selected: br,
  interactive: fr,
  alignLeft: vr,
  alignRight: $r,
  alignCenter: Ar
}, dn = {
  left: ee.alignLeft,
  right: ee.alignRight,
  center: ee.alignCenter
}, _n = R(
  ({ children: a, label: n, layout: l = "auto", className: o, ...c }, r) => /* @__PURE__ */ t("div", { className: ee.scroll, children: /* @__PURE__ */ t(
    "table",
    {
      ref: r,
      className: [ee.table, l === "fixed" ? ee.layoutFixed : "", o ?? ""].filter(Boolean).join(" "),
      "aria-label": n,
      ...c,
      children: a
    }
  ) })
);
_n.displayName = "Table";
const un = R(
  ({ children: a, className: n, ...l }, o) => /* @__PURE__ */ t("thead", { ref: o, className: `${ee.head} ${n ?? ""}`, ...l, children: a })
);
un.displayName = "TableHead";
const mn = R(
  ({ children: a, className: n, ...l }, o) => /* @__PURE__ */ t("tbody", { ref: o, className: n, ...l, children: a })
);
mn.displayName = "TableBody";
const ht = R(
  ({ children: a, selected: n, striped: l, className: o, onClick: c, ...r }, s) => {
    const _ = [
      ee.row,
      c ? ee.interactive : "",
      l ? ee.striped : "",
      n ? ee.selected : "",
      o ?? ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t(
      "tr",
      {
        ref: s,
        className: _,
        onClick: c,
        "aria-selected": n || void 0,
        ...r,
        children: a
      }
    );
  }
);
ht.displayName = "TableRow";
const Zt = R(
  ({ children: a, align: n = "left", sortable: l, sortDirection: o, onSort: c, hideLabel: r, className: s, ..._ }, d) => /* @__PURE__ */ t(
    "th",
    {
      ref: d,
      scope: "col",
      "aria-sort": l ? o === "asc" ? "ascending" : o === "desc" ? "descending" : "none" : void 0,
      className: `${ee.th} ${dn[n]} ${s ?? ""}`,
      ..._,
      children: l ? /* @__PURE__ */ h("button", { type: "button", className: ee.sortButton, onClick: c, children: [
        /* @__PURE__ */ t("span", { className: r ? "sr-only" : void 0, children: a }),
        /* @__PURE__ */ t("span", { className: ee.sortIcon, "aria-hidden": "true", children: o === "asc" ? /* @__PURE__ */ t(Qn, { size: 12, weight: "bold" }) : o === "desc" ? /* @__PURE__ */ t(It, { size: 12, weight: "bold" }) : /* @__PURE__ */ t(It, { size: 12, className: ee.sortIconIdle }) })
      ] }) : /* @__PURE__ */ t("span", { className: r ? "sr-only" : void 0, children: a })
    }
  )
);
Zt.displayName = "TableHeaderCell";
const nt = R(
  ({ children: a, align: n = "left", header: l, className: o, ...c }, r) => {
    const s = `${dn[n]} ${o ?? ""}`;
    return l ? /* @__PURE__ */ t("th", { ref: r, scope: "row", className: s, ...c, children: a }) : /* @__PURE__ */ t("td", { ref: r, className: s, ...c, children: a });
  }
);
nt.displayName = "TableCell";
const Er = "Pagination-module__pagination___mvmcB", Nr = "Pagination-module__button___1sndM", wr = "Pagination-module__active___AA8o-", Je = {
  pagination: Er,
  button: Nr,
  active: wr
};
function yr({
  currentPage: a,
  totalPages: n,
  onPageChange: l,
  className: o
}) {
  const c = Array.from({ length: n }, (r, s) => s + 1);
  return /* @__PURE__ */ h("nav", { "aria-label": "Paginering", className: `${Je.pagination} ${o ?? ""}`, children: [
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        disabled: a <= 1,
        "aria-label": "Forrige side",
        onClick: () => l(a - 1),
        className: Je.button,
        children: "‹"
      }
    ),
    c.map((r) => /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-label": `Side ${r}`,
        "aria-current": r === a ? "page" : void 0,
        onClick: () => l(r),
        className: `${Je.button} ${r === a ? Je.active : ""}`,
        children: r
      },
      r
    )),
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        disabled: a >= n,
        "aria-label": "Neste side",
        onClick: () => l(a + 1),
        className: Je.button,
        children: "›"
      }
    )
  ] });
}
const Zr = "EmptyState-module__root___m61Zc", Mr = "EmptyState-module__header___Lz8r9", Lr = "EmptyState-module__icon___dbe9o", Hr = "EmptyState-module__text___C9ab9", Cr = "EmptyState-module__title___yiN9U", Sr = "EmptyState-module__description___k0geC", kr = "EmptyState-module__action___0jspg", Ce = {
  root: Zr,
  header: Mr,
  icon: Lr,
  text: Hr,
  title: Cr,
  description: Sr,
  action: kr
}, pn = R(
  ({ title: a, description: n, icon: l, action: o, className: c }, r) => /* @__PURE__ */ h("div", { ref: r, className: `${Ce.root} ${c ?? ""}`, children: [
    /* @__PURE__ */ h("div", { className: Ce.header, children: [
      l && /* @__PURE__ */ t("span", { className: Ce.icon, "aria-hidden": "true", children: l }),
      /* @__PURE__ */ h("div", { className: Ce.text, children: [
        /* @__PURE__ */ t("p", { className: Ce.title, children: a }),
        n && /* @__PURE__ */ t("p", { className: Ce.description, children: n })
      ] })
    ] }),
    o && /* @__PURE__ */ t("div", { className: Ce.action, children: o })
  ] })
);
pn.displayName = "EmptyState";
const Tr = "DataTable-module__wrapper___mCPSn", Ir = "DataTable-module__bulkSlot___fNRw-", xr = "DataTable-module__bulkOpen___n5p5x", Fr = "DataTable-module__bulkInner___6trtX", Br = "DataTable-module__bulkBar___P8J-4", Dr = "DataTable-module__bulkSummary___VLt2g", Rr = "DataTable-module__bulkActions___U86kV", Vr = "DataTable-module__tableCard___zeJZ2", Pr = "DataTable-module__rowTrigger___CGq74", zr = "DataTable-module__cellStack___2BHUm", Or = "DataTable-module__cellSubtitle___FYOgl", Wr = "DataTable-module__cellTitle___ReSoA", Gr = "DataTable-module__emptyWrap___nmUBw", Ur = "DataTable-module__skelBar___epSo8", Yr = "DataTable-module__skelPulse___ZTFM6", Kr = "DataTable-module__skelBox___S3EsO", Xr = "DataTable-module__footer___NGdVW", qr = "DataTable-module__pageSummary___QoTWO", q = {
  wrapper: Tr,
  bulkSlot: Ir,
  bulkOpen: xr,
  bulkInner: Fr,
  bulkBar: Br,
  bulkSummary: Dr,
  bulkActions: Rr,
  tableCard: Vr,
  rowTrigger: Pr,
  cellStack: zr,
  cellSubtitle: Or,
  cellTitle: Wr,
  emptyWrap: Gr,
  skelBar: Ur,
  skelPulse: Yr,
  skelBox: Kr,
  footer: Xr,
  pageSummary: qr
}, xt = ["62%", "44%", "72%", "38%", "55%"], hn = 40, Et = {
  width: hn,
  paddingLeft: "var(--space-03)",
  paddingRight: 0
};
function r_({
  columns: a,
  data: n,
  getRowId: l = (m) => m.id,
  selectable: o,
  selectedIds: c = [],
  onSelectionChange: r,
  rowSelectLabel: s,
  sort: _,
  onSortChange: d,
  onRowClick: p,
  rowClickLabel: u,
  rowClickArea: i = "name",
  bulkActions: g,
  bulkSummary: w,
  pagination: $,
  zebra: Z,
  loading: y,
  loadingRows: E = 5,
  emptyMessage: H = "Ingen rader å vise.",
  emptyState: f,
  label: v
}) {
  const m = new Set(c), A = n.map(l), N = n.length > 0 && A.every((C) => m.has(C)), M = A.some((C) => m.has(C)) && !N, b = k(null);
  F(() => {
    b.current && (b.current.indeterminate = M);
  }, [M]);
  const S = k(null), [T, D] = B(Number.POSITIVE_INFINITY);
  F(() => {
    const C = S.current;
    if (!C || typeof ResizeObserver > "u")
      return;
    const L = new ResizeObserver((P) => {
      const J = P[0]?.contentRect.width;
      J && D(J);
    });
    return L.observe(C), () => L.disconnect();
  }, []);
  const V = a.filter((C) => !C.hideBelow || T >= C.hideBelow), te = () => {
    if (r)
      if (N) {
        const C = new Set(A);
        r(c.filter((L) => !C.has(L)));
      } else
        r([.../* @__PURE__ */ new Set([...c, ...A])]);
  }, le = (C) => {
    r && r(
      m.has(C) ? c.filter((L) => L !== C) : [...c, C]
    );
  }, _e = (C) => {
    if (!C.sortable || !d)
      return;
    const L = _?.columnId === C.id && _.direction === "asc" ? "desc" : "asc";
    d({ columnId: C.id, direction: L });
  }, K = (C) => (L) => {
    p && (L.target.closest("input, button, a, label") || p(C));
  }, ue = 200, x = (o ? hn : 0) + V.reduce(
    (C, L) => C + (parseInt(L.width ?? "", 10) || ue),
    0
  );
  return /* @__PURE__ */ h("div", { className: q.wrapper, ref: S, children: [
    /* @__PURE__ */ t("span", { className: "sr-only", role: "status", "aria-live": "polite", children: y ? "Laster …" : "" }),
    o && (g || w) && /* @__PURE__ */ t(
      "div",
      {
        className: `${q.bulkSlot} ${c.length > 0 ? q.bulkOpen : ""}`,
        children: /* @__PURE__ */ t("div", { className: q.bulkInner, children: /* @__PURE__ */ h(
          "div",
          {
            className: q.bulkBar,
            role: "region",
            "aria-label": "Valgte rader",
            "aria-hidden": c.length === 0 || void 0,
            children: [
              /* @__PURE__ */ t("span", { className: q.bulkSummary, children: w ? w(c.length) : `${c.length} valgt` }),
              g && /* @__PURE__ */ t("div", { className: q.bulkActions, children: g })
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ t("div", { className: q.tableCard, children: !y && n.length === 0 ? /* @__PURE__ */ t("div", { className: q.emptyWrap, children: f ?? /* @__PURE__ */ t(pn, { title: H }) }) : /* @__PURE__ */ h(_n, { label: v, layout: "fixed", "aria-busy": y || void 0, style: { minWidth: `${x}px` }, children: [
      /* @__PURE__ */ t(un, { children: /* @__PURE__ */ h(ht, { children: [
        o && /* @__PURE__ */ t(Zt, { style: Et, children: /* @__PURE__ */ t(
          wt,
          {
            ref: b,
            label: "Velg alle rader",
            hideLabel: !0,
            checked: N,
            onChange: te,
            disabled: y
          }
        ) }),
        V.map((C) => /* @__PURE__ */ t(
          Zt,
          {
            align: C.align,
            sortable: C.sortable,
            sortDirection: _?.columnId === C.id ? _.direction : null,
            onSort: () => _e(C),
            style: C.width ? { width: C.width } : void 0,
            children: C.header
          },
          C.id
        ))
      ] }) }),
      /* @__PURE__ */ t(mn, { children: y ? Array.from({ length: E }).map((C, L) => /* @__PURE__ */ h(ht, { children: [
        o && /* @__PURE__ */ t(nt, { style: Et, children: /* @__PURE__ */ t("span", { className: q.skelBox, "aria-hidden": "true" }) }),
        V.map((P, J) => /* @__PURE__ */ t(nt, { align: P.align, children: /* @__PURE__ */ t(
          "span",
          {
            className: q.skelBar,
            "aria-hidden": "true",
            style: { width: xt[J % xt.length] }
          }
        ) }, P.id))
      ] }, `skeleton-${L}`)) : n.map((C, L) => {
        const P = l(C), J = m.has(P);
        return /* @__PURE__ */ h(
          ht,
          {
            selected: J,
            striped: Z ? L % 2 === 1 : void 0,
            onClick: p && i === "row" ? K(C) : void 0,
            children: [
              o && /* @__PURE__ */ t(nt, { style: Et, children: /* @__PURE__ */ t(
                wt,
                {
                  label: s ? s(C) : "Velg rad",
                  hideLabel: !0,
                  checked: J,
                  onChange: () => le(P)
                }
              ) }),
              V.map((me, Ae) => {
                const X = me.render(C), oe = me.subtitle?.(C), re = oe != null && typeof oe != "boolean" && oe !== "", ce = re ? /* @__PURE__ */ h(ge, { children: [
                  /* @__PURE__ */ t("span", { className: q.cellTitle, children: X }),
                  /* @__PURE__ */ t("span", { className: q.cellSubtitle, children: oe })
                ] }) : X;
                let Ee = ce;
                return p && Ae === 0 ? Ee = /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: [q.rowTrigger, re && q.cellStack].filter(Boolean).join(" "),
                    onClick: () => p(C),
                    "aria-label": u ? u(C) : void 0,
                    children: ce
                  }
                ) : re && (Ee = /* @__PURE__ */ t("span", { className: q.cellStack, children: ce })), /* @__PURE__ */ t(nt, { align: me.align, children: Ee }, me.id);
              })
            ]
          },
          P
        );
      }) })
    ] }) }),
    $ && $.totalPages > 1 && /* @__PURE__ */ h("div", { className: q.footer, children: [
      $.summary && /* @__PURE__ */ t("span", { className: q.pageSummary, children: $.summary }),
      /* @__PURE__ */ t(
        yr,
        {
          currentPage: $.currentPage,
          totalPages: $.totalPages,
          onPageChange: $.onPageChange
        }
      )
    ] })
  ] });
}
const jr = "Banner-module__banner___mwAl3", Jr = "Banner-module__info___K-ioh", Qr = "Banner-module__warning___sUmXq", ec = "Banner-module__error___I3HKu", tc = "Banner-module__success___sVsk0", nc = "Banner-module__dot___oFIkJ", ac = "Banner-module__icon___6kX-F", lc = "Banner-module__text___vNAsI", oc = "Banner-module__action___OcfUK", Pe = {
  banner: jr,
  info: Jr,
  warning: Qr,
  error: ec,
  success: tc,
  dot: nc,
  icon: ac,
  text: lc,
  action: oc
}, rc = R(
  ({ variant: a = "info", icon: n, children: l, action: o, className: c, ...r }, s) => /* @__PURE__ */ h(
    "div",
    {
      ref: s,
      role: "status",
      "data-variant": a,
      className: `${Pe.banner} ${Pe[a]} ${c ?? ""}`,
      ...r,
      children: [
        n ? /* @__PURE__ */ t("span", { className: Pe.icon, "aria-hidden": "true", children: n }) : /* @__PURE__ */ t("span", { className: Pe.dot, "aria-hidden": "true" }),
        /* @__PURE__ */ t("div", { className: Pe.text, children: l }),
        o && /* @__PURE__ */ t("div", { className: Pe.action, children: o })
      ]
    }
  )
);
rc.displayName = "Banner";
const cc = "Notice-module__notice___N-bMe", sc = "Notice-module__info___TVAG7", ic = "Notice-module__success___qWYJf", dc = "Notice-module__warning___kIS9g", _c = "Notice-module__danger___YeKcT", uc = "Notice-module__icon___COjtB", mc = "Notice-module__content___tdQXe", pc = "Notice-module__dismiss___0PwGQ", Qe = {
  notice: cc,
  info: sc,
  success: ic,
  warning: dc,
  danger: _c,
  icon: uc,
  content: mc,
  dismiss: pc
}, hc = R(
  ({ variant: a = "info", icon: n, children: l, onDismiss: o, className: c, ...r }, s) => /* @__PURE__ */ h(
    "div",
    {
      ref: s,
      role: "status",
      className: `${Qe.notice} ${Qe[a]} ${c ?? ""}`,
      ...r,
      children: [
        n && /* @__PURE__ */ t("span", { className: Qe.icon, "aria-hidden": "true", children: n }),
        /* @__PURE__ */ t("div", { className: Qe.content, children: l }),
        o && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": "Lukk",
            onClick: o,
            className: Qe.dismiss,
            children: /* @__PURE__ */ t(de, { size: 16, weight: "bold" })
          }
        )
      ]
    }
  )
);
hc.displayName = "Notice";
const gc = "Alert-module__alert___IRmbI", bc = "Alert-module__info___yeWWq", fc = "Alert-module__success___WxkA1", vc = "Alert-module__warning___E2ixX", $c = "Alert-module__danger___aMtI-", Ac = "Alert-module__icon___xqd0Z", Ec = "Alert-module__content___dKCR5", Nc = "Alert-module__close___fPz3E", et = {
  alert: gc,
  info: bc,
  success: fc,
  warning: vc,
  danger: $c,
  icon: Ac,
  content: Ec,
  close: Nc
};
function c_({
  variant: a = "info",
  icon: n,
  children: l,
  open: o,
  onClose: c,
  autoCloseDuration: r,
  className: s
}) {
  const [_, d] = B(o);
  return F(() => {
    d(o);
  }, [o]), F(() => {
    if (_ && r) {
      const p = setTimeout(() => {
        d(!1), c?.();
      }, r);
      return () => clearTimeout(p);
    }
  }, [_, r, c]), _ ? /* @__PURE__ */ h(
    "div",
    {
      role: "alert",
      "aria-live": "assertive",
      className: `${et.alert} ${et[a]} ${s ?? ""}`,
      children: [
        n && /* @__PURE__ */ t("span", { className: et.icon, "aria-hidden": "true", children: n }),
        /* @__PURE__ */ t("div", { className: et.content, children: l }),
        c && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": "Lukk",
            onClick: () => {
              d(!1), c();
            },
            className: et.close,
            children: /* @__PURE__ */ t(de, { size: 16, weight: "bold" })
          }
        )
      ]
    }
  ) : null;
}
const wc = "Loader-module__loader___kwWmf", yc = "Loader-module__spinner___dgodN", Zc = "Loader-module__spin___ikVcT", Mc = "Loader-module__inline___TvzTG", Lc = "Loader-module__sm___-QLZb", Hc = "Loader-module__md___4ukEW", Cc = "Loader-module__lg___j4VPE", Sc = "Loader-module__xl___FSZyk", ut = {
  loader: wc,
  spinner: yc,
  spin: Zc,
  inline: Mc,
  sm: Lc,
  md: Hc,
  lg: Cc,
  xl: Sc
};
function s_({
  label: a = "Laster…",
  size: n = "md",
  inline: l = !1,
  className: o
}) {
  return /* @__PURE__ */ h(
    "span",
    {
      role: "status",
      "aria-label": a,
      className: `${ut.loader} ${ut[n]} ${l ? ut.inline : ""} ${o ?? ""}`,
      children: [
        /* @__PURE__ */ t("span", { className: ut.spinner, "aria-hidden": "true" }),
        /* @__PURE__ */ t("span", { className: "sr-only", children: a })
      ]
    }
  );
}
const kc = "Skeleton-module__line___4XSsY", Tc = "Skeleton-module__skeletonPulse___Wk90N", Ic = "Skeleton-module__card___4C7Zs", xc = "Skeleton-module__column___T2brC", Fc = "Skeleton-module__row___Z81Hu", gt = {
  line: kc,
  skeletonPulse: Tc,
  card: Ic,
  column: xc,
  row: Fc
};
function i_({ width: a, height: n, radius: l = "sm", grow: o, pill: c, className: r }) {
  const s = {
    width: a,
    height: n,
    borderRadius: `var(--radius-${c ? "full" : l})`,
    flex: o ? "1 1 auto" : c ? "0 0 auto" : void 0
  };
  return /* @__PURE__ */ t("div", { className: [gt.line, r].filter(Boolean).join(" "), style: s });
}
function d_({ children: a, layout: n = "column", className: l }) {
  return /* @__PURE__ */ t("div", { className: [gt.card, n === "row" ? gt.row : gt.column, l].filter(Boolean).join(" "), children: a });
}
const Bc = "Toast-module__viewport___zkDgN", Dc = "Toast-module__toast___xO6y2", Rc = "Toast-module__toast-enter___1ELXo", Vc = "Toast-module__toast-enter-top___fXmpw", Pc = "Toast-module__leaving___CjxVt", zc = "Toast-module__toast-exit___vVw-K", Oc = "Toast-module__info___-8Ukt", Wc = "Toast-module__success___uJtOh", Gc = "Toast-module__warning___lkNzP", Uc = "Toast-module__danger___h88Zz", Yc = "Toast-module__icon___3PmeW", Kc = "Toast-module__message___eXbuN", Xc = "Toast-module__action___s3zIH", qc = "Toast-module__dismiss___X-6Gm", Ne = {
  viewport: Bc,
  toast: Dc,
  toastEnter: Rc,
  toastEnterTop: Vc,
  leaving: Pc,
  toastExit: zc,
  info: Oc,
  success: Wc,
  warning: Gc,
  danger: Uc,
  icon: Yc,
  message: Kc,
  action: Xc,
  dismiss: qc
}, Mt = ot(null);
function __() {
  const a = rt(Mt);
  if (!a)
    throw new Error("useToast må brukes innenfor en <ToastProvider>.");
  return a;
}
const jc = 5e3;
function Jc() {
  if (typeof window > "u")
    return 350;
  const a = getComputedStyle(document.documentElement).getPropertyValue("--duration-base").trim(), n = parseFloat(a);
  return Number.isNaN(n) ? 350 : (a.endsWith("ms") ? n : n * 1e3) + 150;
}
const Qc = {
  info: /* @__PURE__ */ t(Xt, { size: 20, weight: "fill" }),
  success: /* @__PURE__ */ t(Gt, { size: 20, weight: "fill" }),
  warning: /* @__PURE__ */ t(on, { size: 20, weight: "fill" }),
  danger: /* @__PURE__ */ t(rn, { size: 20, weight: "fill" })
};
function es({
  children: a,
  position: n = "bottom-center",
  max: l = 4
}) {
  const [o, c] = B([]), r = k(/* @__PURE__ */ new Map()), s = k(/* @__PURE__ */ new Map()), _ = k(0), d = k(0), [p, u] = B(!1), i = (f) => {
    const v = r.current.get(f);
    v?.timeoutId != null && window.clearTimeout(v.timeoutId), r.current.delete(f);
  };
  F(() => (u(!0), () => {
    r.current.forEach((f) => {
      f.timeoutId != null && window.clearTimeout(f.timeoutId);
    }), r.current.clear(), s.current.forEach((f) => window.clearTimeout(f)), s.current.clear();
  }), []);
  const g = I((f) => {
    c((m) => m.filter((A) => A.id !== f));
    const v = s.current.get(f);
    v && (window.clearTimeout(v), s.current.delete(f)), r.current.delete(f);
  }, []), w = I(
    (f) => {
      i(f), c((v) => v.map((m) => m.id === f ? { ...m, leaving: !0 } : m)), s.current.has(f) || s.current.set(f, window.setTimeout(() => g(f), Jc()));
    },
    [g]
  ), $ = I(
    (f) => {
      const v = r.current.get(f);
      !v || v.timeoutId != null || (v.startedAt = Date.now(), v.timeoutId = window.setTimeout(() => w(f), v.remaining));
    },
    [w]
  ), Z = I(
    (f, v = {}) => {
      const m = `toast-${d.current += 1}`, A = v.variant ?? "info", N = v.duration === void 0 ? jc : v.duration, M = N != null && N > 0 ? N : null;
      return c((b) => {
        const S = [...b, { id: m, message: f, variant: A, duration: M, action: v.action, leaving: !1 }];
        if (S.length > l) {
          for (const T of S.slice(0, S.length - l)) {
            i(T.id);
            const D = s.current.get(T.id);
            D && (window.clearTimeout(D), s.current.delete(T.id));
          }
          return S.slice(-l);
        }
        return S;
      }), M != null && (r.current.set(m, { timeoutId: null, remaining: M, startedAt: null }), _.current === 0 && $(m)), m;
    },
    [l, $]
  ), y = I(() => {
    if (_.current += 1, _.current === 1)
      for (const f of r.current.values())
        f.timeoutId != null && (window.clearTimeout(f.timeoutId), f.startedAt != null && (f.remaining = Math.max(0, f.remaining - (Date.now() - f.startedAt))), f.timeoutId = null, f.startedAt = null);
  }, []), E = I(() => {
    if (_.current = Math.max(0, _.current - 1), _.current === 0)
      for (const [f, v] of [...r.current])
        v.timeoutId == null && (v.remaining <= 0 ? w(f) : $(f));
  }, [$, w]), H = Lt(() => {
    const f = (v) => (m, A = {}) => Z(m, { ...A, variant: v });
    return {
      show: Z,
      info: f("info"),
      success: f("success"),
      warning: f("warning"),
      danger: f("danger"),
      dismiss: w
    };
  }, [Z, w]);
  return p ? /* @__PURE__ */ h(Mt.Provider, { value: H, children: [
    a,
    bt(
      /* @__PURE__ */ t(
        "ol",
        {
          className: Ne.viewport,
          "data-position": n,
          "aria-label": "Varsler",
          "aria-live": "polite",
          "aria-atomic": "false",
          onMouseEnter: y,
          onMouseLeave: E,
          onFocusCapture: y,
          onBlurCapture: E,
          children: o.map((f) => /* @__PURE__ */ h(
            "li",
            {
              className: `${Ne.toast} ${Ne[f.variant]} ${f.leaving ? Ne.leaving : ""}`,
              role: f.variant === "danger" ? "alert" : void 0,
              onAnimationEnd: (v) => {
                v.target === v.currentTarget && f.leaving && g(f.id);
              },
              children: [
                /* @__PURE__ */ t("span", { className: Ne.icon, "aria-hidden": "true", children: Qc[f.variant] }),
                /* @__PURE__ */ t("div", { className: Ne.message, children: f.message }),
                f.action && /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: Ne.action,
                    onClick: () => {
                      f.action.onClick(), w(f.id);
                    },
                    children: f.action.label
                  }
                ),
                /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: Ne.dismiss,
                    "aria-label": "Lukk",
                    onClick: (v) => {
                      const m = v.currentTarget.closest("li"), A = m?.nextElementSibling ?? m?.previousElementSibling;
                      w(f.id), A?.querySelector("button")?.focus();
                    },
                    children: /* @__PURE__ */ t(de, { size: 16, weight: "bold" })
                  }
                )
              ]
            },
            f.id
          ))
        }
      ),
      document.body
    )
  ] }) : /* @__PURE__ */ t(Mt.Provider, { value: H, children: a });
}
es.displayName = "ToastProvider";
const ts = "Dialog-module__dialog___4QI6F", ns = "Dialog-module__dialog-enter___bC1FT", as = "Dialog-module__backdrop-enter___Iu6ai", ls = "Dialog-module__container___Enlam", os = "Dialog-module__header___4XcDg", rs = "Dialog-module__title___adFHq", cs = "Dialog-module__close___hym5n", ss = "Dialog-module__content___SosUd", is = "Dialog-module__footer___K2lCC", Se = {
  dialog: ts,
  dialogEnter: ns,
  backdropEnter: as,
  container: ls,
  header: os,
  title: rs,
  close: cs,
  content: ss,
  footer: is
};
function Ft(a) {
  return a instanceof HTMLInputElement && a.type === "file";
}
function ds({ open: a, onClose: n, title: l, children: o, footer: c, className: r, returnFocusRef: s }) {
  const _ = k(null), d = k(null), p = k(!1), u = Y(), i = k(null), [g, w] = B(!1);
  F(() => {
    if (!a)
      return;
    const E = i.current;
    if (!E)
      return;
    const H = () => w(E.scrollHeight > E.clientHeight);
    H();
    const f = new ResizeObserver(H);
    return f.observe(E), () => f.disconnect();
  }, [a]), F(() => {
    const E = _.current;
    if (E) {
      if (a && !E.open)
        d.current = document.activeElement, E.showModal();
      else if (!a && E.open) {
        E.close();
        const H = s?.current ?? d.current;
        H && H.isConnected && H !== document.body && H.focus();
      }
    }
  }, [a, s]);
  const $ = I(
    (E) => {
      if (E.preventDefault(), p.current) {
        p.current = !1;
        return;
      }
      n();
    },
    [n]
  ), Z = I(
    (E) => {
      if (Ft(E.target)) {
        p.current = !0;
        return;
      }
      E.target === _.current && n();
    },
    [n]
  ), y = I((E) => {
    Ft(E.target) && (p.current = !1);
  }, []);
  return /* @__PURE__ */ t(
    "dialog",
    {
      ref: _,
      "aria-labelledby": u,
      onCancel: $,
      onClick: Z,
      onChange: y,
      className: `${Se.dialog} ${r ?? ""}`,
      children: /* @__PURE__ */ h("div", { className: Se.container, children: [
        /* @__PURE__ */ h("header", { className: Se.header, children: [
          /* @__PURE__ */ t("h2", { id: u, className: Se.title, children: l }),
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              "aria-label": "Lukk",
              onClick: n,
              className: Se.close,
              children: /* @__PURE__ */ t(de, { size: 20, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { ref: i, className: Se.content, tabIndex: g ? 0 : void 0, children: o }),
        c && /* @__PURE__ */ t("footer", { className: Se.footer, children: c })
      ] })
    }
  );
}
const _s = "Sheet-module__sheet___4btR1", us = "Sheet-module__sheet-enter___Havmm", ms = "Sheet-module__left___9ursm", ps = "Sheet-module__sheet-enter-left___dLT4C", hs = "Sheet-module__backdrop-enter___Yb0N2", gs = "Sheet-module__right___FAhmN", bs = "Sheet-module__container___EAOfa", fs = "Sheet-module__header___CcPps", vs = "Sheet-module__title___o68zm", $s = "Sheet-module__close___7-U3O", As = "Sheet-module__content___pPiGe", ke = {
  sheet: _s,
  sheetEnter: us,
  left: ms,
  sheetEnterLeft: ps,
  backdropEnter: hs,
  right: gs,
  container: bs,
  header: fs,
  title: vs,
  close: $s,
  content: As
};
function u_({
  open: a,
  onClose: n,
  title: l,
  children: o,
  side: c = "right",
  className: r
}) {
  const s = k(null), _ = k(null), d = Y();
  F(() => {
    const i = s.current;
    i && (a && !i.open ? (_.current = document.activeElement, i.showModal()) : !a && i.open && (i.close(), _.current?.focus()));
  }, [a]);
  const p = I(
    (i) => {
      i.preventDefault(), n();
    },
    [n]
  ), u = I(
    (i) => {
      i.target === s.current && n();
    },
    [n]
  );
  return /* @__PURE__ */ t(
    "dialog",
    {
      ref: s,
      "aria-labelledby": d,
      onCancel: p,
      onClick: u,
      className: `${ke.sheet} ${ke[c]} ${r ?? ""}`,
      children: /* @__PURE__ */ h("div", { className: ke.container, children: [
        /* @__PURE__ */ h("header", { className: ke.header, children: [
          /* @__PURE__ */ t("h2", { id: d, className: ke.title, children: l }),
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              "aria-label": "Lukk",
              onClick: n,
              className: ke.close,
              children: /* @__PURE__ */ t(de, { size: 20, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { className: ke.content, children: o })
      ] })
    }
  );
}
const Es = 5, Ns = 26.25, ws = 64, Bt = 32;
function tt(a) {
  const n = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return a * n;
}
function ys({
  collapsedRem: a = Ns,
  expandedVh: n = 90,
  peekPx: l = ws,
  resetKey: o,
  startPeeked: c = !1,
  expandSignal: r,
  expandLevel: s = "collapsed",
  expandKey: _,
  expandDelayMs: d = 0
} = {}) {
  const p = (x) => window.innerHeight * x / 100, [u, i] = B(() => c ? l : tt(a)), [g, w] = B(!1), $ = k(null), Z = k(l);
  Z.current = l;
  const y = k(c ? "peek" : "collapsed"), E = I(
    (x) => Math.min(p(n), Math.max(l, x)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, n]
  ), H = k(u);
  H.current = u;
  const f = k(null), v = I(() => {
    f.current !== null && (clearTimeout(f.current), f.current = null);
  }, []);
  F(() => v, [v]);
  const m = (x, { onlyGrow: C = !1, delayed: L = !1 } = {}) => {
    v();
    const P = () => {
      f.current = null;
      const J = x === "expanded" ? p(n) : tt(a);
      C && H.current >= J || (y.current = x, i(J));
    };
    L && d > 0 ? f.current = setTimeout(P, d) : P();
  };
  F(() => {
    v(), y.current = c ? "peek" : "collapsed", i(c ? Z.current : tt(a));
  }, [o]);
  const A = k(r), N = k(s);
  F(() => {
    const x = r === !0 && A.current !== !0, C = N.current !== s;
    A.current = r, N.current = s, !(g || r === void 0) && (r ? m(s, { delayed: x && !C }) : (v(), y.current = "peek", i(Z.current)));
  }, [r, s]);
  const M = k(!0);
  F(() => {
    if (M.current) {
      M.current = !1;
      return;
    }
    g || !r || m(s, { onlyGrow: !0, delayed: !0 });
  }, [_]), F(() => {
    g || y.current === "peek" && i(l);
  }, [l]);
  const b = k(null), S = I(
    (x) => {
      $.current && ($.current.lastY = x.clientY, b.current === null && (b.current = requestAnimationFrame(() => {
        b.current = null;
        const C = $.current;
        C && i(E(C.startHeight + (C.startY - C.lastY)));
      })));
    },
    [E]
  ), T = I(
    (x) => {
      const C = x >= p(n) - 1;
      y.current = C ? "peek" : "expanded", i(C ? l : p(n));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, l]
  ), D = I(() => {
    b.current !== null && (cancelAnimationFrame(b.current), b.current = null);
    const x = $.current;
    if ($.current = null, w(!1), !x)
      return;
    if (Math.abs(x.lastY - x.startY) >= Es) {
      const L = x.lastY < x.startY;
      y.current = L ? "expanded" : "peek", i(L ? p(n) : l);
    } else
      T(x.startHeight);
  }, [T, n, l]), V = I(
    (x) => {
      x.button > 0 || (v(), $.current = { startY: x.clientY, startHeight: u, lastY: x.clientY }, w(!0));
    },
    [u, v]
  ), te = I(
    (x) => {
      switch (v(), x.key) {
        case "ArrowUp":
          x.preventDefault(), y.current = "other", i((C) => E(C + Bt));
          break;
        case "ArrowDown":
          x.preventDefault(), y.current = "other", i((C) => E(C - Bt));
          break;
        case "Home":
          x.preventDefault(), y.current = "peek", i(l);
          break;
        case "End":
          x.preventDefault(), y.current = "expanded", i(p(n));
          break;
        case "Enter":
        case " ":
          x.preventDefault(), T(u);
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [E, l, n, u, T, v]
  );
  F(() => {
    if (g)
      return window.addEventListener("pointermove", S), window.addEventListener("pointerup", D), window.addEventListener("pointercancel", D), () => {
        window.removeEventListener("pointermove", S), window.removeEventListener("pointerup", D), window.removeEventListener("pointercancel", D), b.current !== null && (cancelAnimationFrame(b.current), b.current = null);
      };
  }, [g, S, D]), F(() => {
    const x = () => {
      if ($.current)
        return;
      const C = y.current;
      i(C === "expanded" ? p(n) : C === "collapsed" ? E(tt(a)) : C === "peek" ? Z.current : (L) => E(L));
    };
    return window.addEventListener("resize", x), () => window.removeEventListener("resize", x);
  }, [E, n, a]);
  const le = l, _e = p(n), K = u > (tt(a) + _e) / 2, ue = I(() => {
    v(), y.current = "expanded", i(p(n));
  }, [n]);
  return {
    height: u,
    minHeight: le,
    maxHeight: _e,
    isDragging: g,
    isExpanded: K,
    dragHandleProps: { onPointerDown: V, onKeyDown: te },
    expand: ue
  };
}
const Zs = "BottomSheet-module__sheet___SZNZf", Ms = "BottomSheet-module__fixed___nB3g1", Ls = "BottomSheet-module__absolute___F3KhV", Hs = "BottomSheet-module__grabber___yYqH6", Cs = "BottomSheet-module__headerDraggable___rdTHh", Ss = "BottomSheet-module__settling___Y644y", ks = "BottomSheet-module__bar___hLLcf", ze = {
  sheet: Zs,
  fixed: Ms,
  absolute: Ls,
  grabber: Hs,
  headerDraggable: Cs,
  settling: Ss,
  bar: ks
}, Dt = 'button, a[href], input, select, textarea, [role="button"], [role="link"]', mt = 8, Rt = ":scope > * > header", Ts = ":scope > * > [data-panel-subheader]";
function Is(a) {
  return a <= 0 ? "Minimert" : a >= 100 ? "Maks høyde" : `${a} % åpent`;
}
const xs = R(
  ({
    children: a,
    className: n,
    position: l = "fixed",
    startPeeked: o,
    expandSignal: c,
    expandLevel: r,
    expandKey: s,
    expandDelayMs: _,
    resetKey: d,
    collapsedRem: p,
    expandedVh: u,
    headerDraggable: i = !0,
    grabberLabel: g = "Endre høyde på panel",
    grabberValueText: w = Is,
    onHeightChange: $,
    onExpandedChange: Z,
    label: y,
    focusOnOpen: E = !0,
    announceChanges: H = !0,
    onAnnounce: f
  }, v) => {
    const m = k(null), A = k(null), [N, M] = B(void 0), { height: b, minHeight: S, maxHeight: T, isDragging: D, isExpanded: V, dragHandleProps: te, expand: le } = ys({
      resetKey: d,
      peekPx: N,
      startPeeked: o,
      expandSignal: c,
      expandLevel: r,
      expandKey: s,
      expandDelayMs: _,
      collapsedRem: p,
      expandedVh: u
    });
    bn(v, () => ({ expand: le }), [le]);
    const _e = k({
      header: null,
      subHeader: null,
      observer: null
    });
    at(() => {
      const X = A.current, oe = m.current?.querySelector(Rt) ?? null, re = m.current?.querySelector(Ts) ?? null, ce = _e.current;
      if (ce.observer && ce.header === oe && ce.subHeader === re)
        return;
      if (ce.observer?.disconnect(), ce.header = oe, ce.subHeader = re, ce.observer = null, !X || !oe) {
        M(void 0);
        return;
      }
      const Ee = () => M(X.offsetHeight + oe.offsetHeight + (re?.offsetHeight ?? 0));
      Ee();
      const be = new ResizeObserver(Ee);
      be.observe(X), be.observe(oe), re && be.observe(re), ce.observer = be;
    }), F(() => () => _e.current.observer?.disconnect(), []);
    const [K, ue] = B(""), x = k(f);
    x.current = f, F(() => {
      const X = m.current;
      !E || !X || X.contains(document.activeElement) || X.focus({ preventScroll: !0 });
    }, [y, E]), F(() => {
      if (!H || !y)
        return;
      if (x.current) {
        x.current(y);
        return;
      }
      ue("");
      const X = window.setTimeout(() => ue(y), 50);
      return () => window.clearTimeout(X);
    }, [y, H]), F(() => {
      D || Z?.(V);
    }, [V, D]), at(() => {
      $?.(b, { immediate: D });
    }, [D, b, $]);
    const C = k(Z), L = k($);
    F(() => {
      C.current = Z;
    }, [Z]), F(() => {
      L.current = $;
    }, [$]), F(() => () => {
      C.current?.(!1), L.current?.(0, { immediate: !0 });
    }, []);
    const P = (X) => {
      if (!i || X.button > 0)
        return;
      const oe = X.target, re = oe.closest("header");
      !re || re !== m.current?.querySelector(Rt) || oe.closest(Dt) || Array.from(re.querySelectorAll(Dt)).some((Ee) => {
        const be = Ee.getBoundingClientRect();
        return X.clientX >= be.left - mt && X.clientX <= be.right + mt && X.clientY >= be.top - mt && X.clientY <= be.bottom + mt;
      }) || te.onPointerDown(X);
    }, J = [
      ze.sheet,
      ze[l],
      i ? ze.headerDraggable : "",
      D ? "" : ze.settling,
      n ?? ""
    ].filter(Boolean).join(" "), me = T - S, Ae = Math.min(100, Math.max(0, me > 0 ? Math.round((b - S) / me * 100) : 0));
    return (
      // tabIndex -1: fokuserbar fra kode (focusOnOpen), men ikke et eget tabulatorstopp.
      /* @__PURE__ */ h("div", { ref: m, tabIndex: -1, className: J, style: { height: b }, onPointerDown: P, children: [
        /* @__PURE__ */ t(
          "div",
          {
            ref: A,
            role: "separator",
            tabIndex: 0,
            "aria-orientation": "horizontal",
            "aria-label": g,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": Ae,
            "aria-valuetext": w(Ae),
            className: ze.grabber,
            ...te,
            children: /* @__PURE__ */ t("span", { className: ze.bar })
          }
        ),
        a,
        H && !f && /* @__PURE__ */ t("span", { className: "sr-only", role: "status", "aria-live": "polite", children: K })
      ] })
    );
  }
);
xs.displayName = "BottomSheet";
const Fs = "Dropdown-module__wrapper___Zyl0q", Bs = "Dropdown-module__trigger___I0GgP", Ds = "Dropdown-module__menu___4sTYp", Rs = "Dropdown-module__menu-enter___Q15yI", Vs = "Dropdown-module__start___AAl2C", Ps = "Dropdown-module__end___Hb8HP", zs = "Dropdown-module__groupLabel___aSol7", Os = "Dropdown-module__item___C8H3a", Ws = "Dropdown-module__danger___QgHvS", Gs = "Dropdown-module__selected___-8iQi", Us = "Dropdown-module__icon___Bji66", Ys = "Dropdown-module__separator___9ebsf", Ks = "Dropdown-module__portalMenu___SIXIz", ve = {
  wrapper: Fs,
  trigger: Bs,
  menu: Ds,
  menuEnter: Rs,
  start: Vs,
  end: Ps,
  groupLabel: zs,
  item: Os,
  danger: Ws,
  selected: Gs,
  icon: Us,
  separator: Ys,
  portalMenu: Ks
};
function m_({ trigger: a, groups: n, align: l = "start", className: o }) {
  const r = `${Y()}-menu`, s = k(null), _ = k(null), [d, p] = B(!1), [u, i] = B(-1), [g, w] = B({ top: 0, left: 0 }), $ = n.flatMap((m) => m.items), Z = I(() => {
    p(!1), i(-1), s.current?.focus();
  }, []), y = I(() => {
    const m = s.current, A = _.current;
    if (!m || !A)
      return;
    const N = m.getBoundingClientRect(), M = A.getBoundingClientRect(), b = 4;
    let S = N.bottom + b, T = l === "end" ? N.right - M.width : N.left;
    S + M.height > window.innerHeight - 8 && (S = N.top - M.height - b), T = Math.max(8, Math.min(T, window.innerWidth - M.width - 8)), w({ top: S, left: T });
  }, [l]);
  at(() => {
    d && y();
  }, [d, y]), F(() => {
    if (!d)
      return;
    const m = (N) => {
      _.current && !_.current.contains(N.target) && !s.current?.contains(N.target) && Z();
    }, A = () => Z();
    return document.addEventListener("mousedown", m), window.addEventListener("scroll", A, !0), () => {
      document.removeEventListener("mousedown", m), window.removeEventListener("scroll", A, !0);
    };
  }, [d, Z]);
  const E = (m) => {
    if (m.key === "Escape" && d) {
      m.preventDefault(), m.stopPropagation(), Z();
      return;
    }
    (m.key === "ArrowDown" || m.key === "Enter" || m.key === " ") && (m.preventDefault(), p(!0), i(0));
  }, H = (m) => {
    switch (m.key) {
      case "ArrowDown":
        m.preventDefault(), i((A) => (A + 1) % $.length);
        break;
      case "ArrowUp":
        m.preventDefault(), i((A) => (A - 1 + $.length) % $.length);
        break;
      case "Home":
        m.preventDefault(), i(0);
        break;
      case "End":
        m.preventDefault(), i($.length - 1);
        break;
      case "Enter":
      case " ":
        m.preventDefault(), u >= 0 && !$[u].disabled && ($[u].onClick(), Z());
        break;
      case "Escape":
        m.preventDefault(), m.stopPropagation(), Z();
        break;
      case "Tab":
        Z();
        break;
    }
  };
  F(() => {
    d && u >= 0 && _.current && _.current.querySelectorAll("[role='menuitem']")[u]?.focus();
  }, [u, d]);
  let f = 0;
  const v = /* @__PURE__ */ t(
    "div",
    {
      ref: _,
      id: r,
      role: "menu",
      onKeyDown: H,
      className: ve.portalMenu,
      style: { top: g.top, left: g.left },
      children: n.map((m, A) => /* @__PURE__ */ h("div", { role: "group", "aria-label": m.label, children: [
        m.label && /* @__PURE__ */ t("span", { className: ve.groupLabel, children: m.label }),
        m.items.map((N) => {
          const M = f++;
          return /* @__PURE__ */ h(
            "button",
            {
              role: "menuitem",
              tabIndex: M === u ? 0 : -1,
              disabled: N.disabled,
              "aria-disabled": N.disabled,
              onClick: () => {
                N.disabled || (N.onClick(), Z());
              },
              className: `${ve.item} ${N.danger ? ve.danger : ""} ${N.selected ? ve.selected : ""}`,
              children: [
                N.icon && /* @__PURE__ */ t("span", { className: ve.icon, "aria-hidden": "true", children: N.icon }),
                N.label
              ]
            },
            N.id
          );
        }),
        A < n.length - 1 && /* @__PURE__ */ t("hr", { className: ve.separator, role: "separator" })
      ] }, A))
    }
  );
  return /* @__PURE__ */ h("div", { className: `${ve.wrapper} ${o ?? ""}`, children: [
    /* @__PURE__ */ t(
      "button",
      {
        ref: s,
        "aria-haspopup": "true",
        "aria-expanded": d,
        "aria-controls": r,
        onClick: () => d ? Z() : p(!0),
        onKeyDown: E,
        className: ve.trigger,
        children: a
      }
    ),
    d && bt(
      v,
      // Inne i en modal <dialog> (showModal → top layer) ville en portal
      // til document.body havne bak dialogen uansett z-index (jf. Combobox).
      s.current?.closest("dialog") ?? document.body
    )
  ] });
}
const Xs = "Popover-module__wrapper___sKqNa", qs = "Popover-module__trigger___ylde3", js = "Popover-module__content___0R1Sx", Js = "Popover-module__popover-enter___bxUWW", Qs = "Popover-module__start___cU0hQ", ei = "Popover-module__center___1-bCx", ti = "Popover-module__end___NDfi-", pt = {
  wrapper: Xs,
  trigger: qs,
  content: js,
  popoverEnter: Js,
  start: Qs,
  center: ei,
  end: ti
};
function p_({ trigger: a, children: n, align: l = "center", label: o, className: c }) {
  const s = `${Y()}-content`, _ = k(null), [d, p] = B(!1);
  return F(() => {
    if (!d)
      return;
    const u = (g) => {
      _.current && !_.current.contains(g.target) && p(!1);
    }, i = (g) => {
      g.key === "Escape" && p(!1);
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", i), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", i);
    };
  }, [d]), /* @__PURE__ */ h("div", { ref: _, className: `${pt.wrapper} ${c ?? ""}`, children: [
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-expanded": d,
        "aria-controls": s,
        onClick: () => p(!d),
        className: pt.trigger,
        children: a
      }
    ),
    d && /* @__PURE__ */ t(
      "div",
      {
        id: s,
        role: "dialog",
        "aria-label": o ?? "Popover",
        className: `${pt.content} ${pt[l]}`,
        children: n
      }
    )
  ] });
}
const ni = "Tooltip-module__wrapper___cyd3i", ai = "Tooltip-module__tooltip___uu3d5", li = "Tooltip-module__tooltip-enter___hPgJg", oi = "Tooltip-module__top___lf6O8", ri = "Tooltip-module__bottom___0dKdq", ci = "Tooltip-module__left___zSsLk", si = "Tooltip-module__right___3RLFp", ii = "Tooltip-module__portalTooltip___S8GeT", di = "Tooltip-module__rich___vXPyH", _i = "Tooltip-module__title___bX8-Z", ui = "Tooltip-module__body___psXOb", mi = "Tooltip-module__pointerLeft___B-kkB", pi = "Tooltip-module__pointerTop___ISeKX", Te = {
  wrapper: ni,
  tooltip: ai,
  tooltipEnter: li,
  top: oi,
  bottom: ri,
  left: ci,
  right: si,
  portalTooltip: ii,
  rich: di,
  title: _i,
  body: ui,
  pointerLeft: mi,
  pointerTop: pi
};
function lt({
  content: a,
  title: n,
  children: l,
  position: o = "top",
  align: c = "center",
  className: r,
  disableOnMobile: s = !0
}) {
  const d = `${Y()}-tooltip`, [p, u] = B(!1), i = k(null), g = k(null), [w, $] = B({ top: 0, left: 0 }), Z = k(void 0), y = () => {
    s && window.matchMedia("(hover: none)").matches || (clearTimeout(Z.current), Z.current = setTimeout(() => u(!0), 200));
  }, E = () => {
    clearTimeout(Z.current), u(!1);
  }, H = I(() => {
    const f = i.current, v = g.current;
    if (!f || !v)
      return;
    const m = f.getBoundingClientRect(), A = v.getBoundingClientRect(), N = 8;
    let M = 0, b = 0;
    switch (o) {
      case "top":
        M = m.top - A.height - N, b = m.left + m.width / 2 - A.width / 2;
        break;
      case "bottom":
        M = m.bottom + N, b = m.left + m.width / 2 - A.width / 2;
        break;
      case "left":
        M = c === "start" ? m.top : m.top + m.height / 2 - A.height / 2, b = m.left - A.width - N;
        break;
      case "right":
        M = c === "start" ? m.top : m.top + m.height / 2 - A.height / 2, b = m.right + N;
        break;
    }
    b = Math.max(8, Math.min(b, window.innerWidth - A.width - 8)), M = Math.max(8, Math.min(M, window.innerHeight - A.height - 8)), $({ top: M, left: b });
  }, [o, c]);
  return at(() => {
    p && H();
  }, [p, H]), F(() => {
    if (!p)
      return;
    const f = () => H();
    return window.addEventListener("scroll", f, !0), window.addEventListener("resize", f), () => {
      window.removeEventListener("scroll", f, !0), window.removeEventListener("resize", f);
    };
  }, [p, H]), /* @__PURE__ */ h(
    "span",
    {
      ref: i,
      className: `${Te.wrapper} ${r ?? ""}`,
      onMouseEnter: y,
      onMouseLeave: E,
      onFocus: y,
      onBlur: E,
      children: [
        /* @__PURE__ */ t("span", { "aria-describedby": p ? d : void 0, children: l }),
        p && bt(
          /* @__PURE__ */ h(
            "span",
            {
              ref: g,
              id: d,
              role: "tooltip",
              className: [
                Te.portalTooltip,
                n ? Te.rich : "",
                // Pointer when the tooltip sits to the right of the trigger —
                // applies to both rich and simple variants so the toolbar rail
                // has a consistent visual language.
                o === "right" ? Te.pointerLeft : "",
                // Align the arrow to the tooltip TOP (rather than its centre)
                // when the tooltip top is flush with the trigger top — the 40px
                // toolbar-icon case. For align="center" the default centred arrow
                // matches the trigger's midpoint.
                o === "right" && c === "start" ? Te.pointerTop : ""
              ].filter(Boolean).join(" "),
              style: { top: w.top, left: w.left },
              children: [
                n && /* @__PURE__ */ t("span", { className: Te.title, children: n }),
                /* @__PURE__ */ t("span", { className: Te.body, children: a })
              ]
            }
          ),
          document.body
        )
      ]
    }
  );
}
const hi = "ColorPicker-module__wrapper___Nw47x", gi = "ColorPicker-module__label___oQzUZ", bi = "ColorPicker-module__row___d-52x", fi = "ColorPicker-module__disabled___qIidS", vi = "ColorPicker-module__swatch___EYEy7", $i = "ColorPicker-module__hiddenInput___-brmd", Ai = "ColorPicker-module__stretch___dF4gm", Ei = "ColorPicker-module__hexInput___6YRDI", we = {
  wrapper: hi,
  label: gi,
  row: bi,
  disabled: fi,
  swatch: vi,
  hiddenInput: $i,
  stretch: Ai,
  hexInput: Ei
}, Ni = R(
  ({ label: a, value: n = "#0037F8", onChange: l, disabled: o, className: c, id: r, hideLabel: s = !1, stretch: _ = !1 }, d) => {
    const p = Y(), u = r ?? p, i = `${u}-hex`, [g, w] = B(n), $ = I(
      (y) => {
        const E = y.target.value;
        w(E), l?.(E);
      },
      [l]
    ), Z = I(
      (y) => {
        const E = y.target.value;
        w(E), /^#[0-9A-Fa-f]{6}$/.test(E) && l?.(E);
      },
      [l]
    );
    return /* @__PURE__ */ h("div", { className: `${we.wrapper} ${o ? we.disabled : ""} ${c ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: i, className: `${we.label} ${s ? "sr-only" : ""}`, children: a }),
      /* @__PURE__ */ h("div", { className: `${we.row} ${_ ? we.stretch : ""}`, children: [
        /* @__PURE__ */ t("label", { className: we.swatch, style: { backgroundColor: g }, children: /* @__PURE__ */ t(
          "input",
          {
            ref: d,
            id: u,
            type: "color",
            value: g,
            onChange: $,
            disabled: o,
            className: we.hiddenInput,
            "aria-label": a
          }
        ) }),
        /* @__PURE__ */ t(
          "input",
          {
            id: i,
            type: "text",
            value: g,
            onChange: Z,
            disabled: o,
            className: we.hexInput,
            spellCheck: !1,
            maxLength: 7
          }
        )
      ] })
    ] });
  }
);
Ni.displayName = "ColorPicker";
const wi = "Slider-module__wrapper___3qLNN", yi = "Slider-module__labelRow___BmVW1", Zi = "Slider-module__label___7iY-I", Mi = "Slider-module__control___DjmAn", Li = "Slider-module__input___8YnqD", Hi = "Slider-module__value___-M4Hv", Oe = {
  wrapper: wi,
  labelRow: yi,
  label: Zi,
  control: Mi,
  input: Li,
  value: Hi
}, Ci = R(
  ({ label: a, showValue: n = !0, formatValue: l, hideLabel: o = !1, className: c, id: r, value: s, ..._ }, d) => {
    const p = Y(), u = r ?? p, i = l ? l(Number(s ?? 0)) : String(s ?? 0);
    return /* @__PURE__ */ h("div", { className: `${Oe.wrapper} ${c ?? ""}`, children: [
      /* @__PURE__ */ h("div", { className: Oe.labelRow, children: [
        /* @__PURE__ */ t("label", { htmlFor: u, className: `${Oe.label} ${o ? "sr-only" : ""}`, children: a }),
        n && !o && /* @__PURE__ */ t("output", { htmlFor: u, className: Oe.value, children: i })
      ] }),
      /* @__PURE__ */ t("div", { className: Oe.control, children: /* @__PURE__ */ t(
        "input",
        {
          ref: d,
          id: u,
          type: "range",
          value: s,
          className: Oe.input,
          ..._
        }
      ) })
    ] });
  }
);
Ci.displayName = "Slider";
const Si = "AppHeader-module__header___qsyM4", ki = "AppHeader-module__left___YCGqY", Ti = "AppHeader-module__brand___46CvU", Ii = "AppHeader-module__brandSm___dhKpK", xi = "AppHeader-module__brandButton___qqWJm", Fi = "AppHeader-module__logo___evYfE", Bi = "AppHeader-module__title___c51gm", Di = "AppHeader-module__titleButton___t5zBM", Ri = "AppHeader-module__titleButtonIcon___i8fGZ", Vi = "AppHeader-module__titleAction___9lEdd", Pi = "AppHeader-module__divider___J1Y77", zi = "AppHeader-module__subtitle___V1-vY", Oi = "AppHeader-module__contextTitle___E2WsU", Wi = "AppHeader-module__contextSubtitle___XrXbP", Gi = "AppHeader-module__backArea___YcIxd", Ui = "AppHeader-module__backText___XH2Iw", Yi = "AppHeader-module__hasCenter___hnLPO", Ki = "AppHeader-module__center___Zfwxd", Xi = "AppHeader-module__right___KZ-gW", qi = "AppHeader-module__userChip___GbZkx", ji = "AppHeader-module__userName___IYg2F", Ji = "AppHeader-module__userRole___HKQ9g", G = {
  header: Si,
  left: ki,
  brand: Ti,
  brandSm: Ii,
  brandButton: xi,
  logo: Fi,
  title: Bi,
  titleButton: Di,
  titleButtonIcon: Ri,
  titleAction: Vi,
  divider: Pi,
  subtitle: zi,
  contextTitle: Oi,
  contextSubtitle: Wi,
  backArea: Gi,
  backText: Ui,
  hasCenter: Yi,
  center: Ki,
  right: Xi,
  userChip: qi,
  userName: ji,
  userRole: Ji
};
function h_({
  logo: a,
  title: n,
  onTitleClick: l,
  titleSize: o = "md",
  showTitleCaret: c = !0,
  subtitle: r,
  titleAction: s,
  onBack: _,
  backLabel: d,
  center: p,
  actions: u,
  user: i,
  className: g
}) {
  const w = !!_, $ = `${G.title} ${o === "sm" ? G.titleSm : ""}`, Z = `${G.brand} ${o === "sm" ? G.brandSm : ""}`, y = /* @__PURE__ */ h(ge, { children: [
    a && /* @__PURE__ */ t("span", { className: G.logo, children: a }),
    /* @__PURE__ */ t("span", { className: $, children: n })
  ] });
  return /* @__PURE__ */ h("header", { className: `${G.header} ${p ? G.hasCenter : ""} ${g ?? ""}`, children: [
    /* @__PURE__ */ t("div", { className: G.left, children: w ? /* @__PURE__ */ h(ge, { children: [
      /* @__PURE__ */ h(
        "button",
        {
          type: "button",
          className: G.backArea,
          onClick: _,
          "aria-label": d ?? "Gå tilbake",
          children: [
            /* @__PURE__ */ t(ft, { size: 18, "aria-hidden": "true" }),
            d && /* @__PURE__ */ t("span", { className: G.backText, children: d })
          ]
        }
      ),
      /* @__PURE__ */ t("span", { className: G.contextTitle, children: n }),
      r && /* @__PURE__ */ t("span", { className: G.contextSubtitle, children: r })
    ] }) : /* @__PURE__ */ h(ge, { children: [
      l ? /* @__PURE__ */ h(
        "button",
        {
          type: "button",
          className: `${G.title} ${G.titleButton}`,
          onClick: l,
          children: [
            /* @__PURE__ */ t("span", { children: n }),
            c && /* @__PURE__ */ t(
              Ot,
              {
                size: 16,
                weight: "bold",
                "aria-hidden": "true",
                className: G.titleButtonIcon
              }
            )
          ]
        }
      ) : /* @__PURE__ */ t("span", { className: Z, children: y }),
      s && /* @__PURE__ */ t("span", { className: G.titleAction, children: s }),
      r && /* @__PURE__ */ h(ge, { children: [
        /* @__PURE__ */ t("span", { className: G.divider }),
        /* @__PURE__ */ t("span", { className: G.subtitle, children: r })
      ] })
    ] }) }),
    p && /* @__PURE__ */ t("div", { className: G.center, children: p }),
    /* @__PURE__ */ h("div", { className: G.right, children: [
      u,
      i && /* @__PURE__ */ h(ge, { children: [
        u && /* @__PURE__ */ t("span", { className: G.divider }),
        /* @__PURE__ */ h("div", { className: G.userChip, children: [
          /* @__PURE__ */ t(
            Qo,
            {
              alt: i.name,
              initials: i.initials,
              src: i.avatarUrl,
              size: "sm"
            }
          ),
          /* @__PURE__ */ h("div", { children: [
            /* @__PURE__ */ t("div", { className: G.userName, children: i.name }),
            i.role && /* @__PURE__ */ t("div", { className: G.userRole, children: i.role })
          ] })
        ] })
      ] })
    ] })
  ] });
}
const Qi = "PageHeader-module__header___W4r3L", ed = "PageHeader-module__left___Kcr-c", td = "PageHeader-module__backBtn___LZMYk", nd = "PageHeader-module__textCol___o3iND", ad = "PageHeader-module__title___GGnoW", ld = "PageHeader-module__description___MRGDc", od = "PageHeader-module__actions___KFuAm", rd = "PageHeader-module__compact___peIII", ye = {
  header: Qi,
  left: ed,
  backBtn: td,
  textCol: nd,
  title: ad,
  description: ld,
  actions: od,
  compact: rd
};
function g_({
  title: a,
  description: n,
  onBack: l,
  backLabel: o = "Tilbake",
  actions: c,
  compact: r = !1,
  className: s
}) {
  return /* @__PURE__ */ h("header", { className: `${ye.header} ${r ? ye.compact : ""} ${s ?? ""}`, children: [
    /* @__PURE__ */ h("div", { className: ye.left, children: [
      l && /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: ye.backBtn,
          onClick: l,
          "aria-label": o,
          children: /* @__PURE__ */ t(ft, { size: 20, "aria-hidden": "true" })
        }
      ),
      /* @__PURE__ */ h("div", { className: ye.textCol, children: [
        /* @__PURE__ */ t("h1", { className: ye.title, children: a }),
        n && !r && /* @__PURE__ */ t("p", { className: ye.description, children: n })
      ] })
    ] }),
    c && /* @__PURE__ */ t("div", { className: ye.actions, children: c })
  ] });
}
const cd = "SideNav-module__nav___H-s5B", sd = "SideNav-module__navBorderless___l3cwU", id = "SideNav-module__navBody___yX8s-", dd = "SideNav-module__group___FY5gj", _d = "SideNav-module__groupLabel___JTo39", ud = "SideNav-module__item___8T6AH", md = "SideNav-module__itemActive___W2dsZ", pd = "SideNav-module__icon___U-O98", hd = "SideNav-module__navCollapsed___LwvV2", gd = "SideNav-module__itemCollapsed___N07sG", bd = "SideNav-module__toggle___Og-yk", fd = "SideNav-module__toggleIcon___Bk-nr", vd = "SideNav-module__toggleLabel___JIpst", $d = "SideNav-module__toggleCollapsed___M4ZaL", Ad = "SideNav-module__resizeHandle___VcqIT", Ed = "SideNav-module__resizeHandleActive___9-xpF", Q = {
  nav: cd,
  navBorderless: sd,
  navBody: id,
  group: dd,
  groupLabel: _d,
  item: ud,
  itemActive: md,
  icon: pd,
  navCollapsed: hd,
  itemCollapsed: gd,
  toggle: bd,
  toggleIcon: fd,
  toggleLabel: vd,
  toggleCollapsed: $d,
  resizeHandle: Ad,
  resizeHandleActive: Ed
}, Tt = ot({});
function b_({ id: a, icon: n, children: l, description: o }) {
  const { activeId: c, collapsed: r, onSelect: s } = rt(Tt), _ = c === a, d = /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      className: `${Q.item} ${_ ? Q.itemActive : ""} ${r ? Q.itemCollapsed : ""}`,
      onClick: () => s?.(a),
      "aria-current": _ ? "page" : void 0,
      "aria-label": r && typeof l == "string" ? l : void 0,
      children: [
        n && /* @__PURE__ */ t("span", { className: Q.icon, children: n }),
        !r && l
      ]
    }
  );
  return r && typeof l == "string" ? /* @__PURE__ */ t(
    lt,
    {
      position: "right",
      align: "start",
      title: o ? l : void 0,
      content: o ?? l,
      children: d
    }
  ) : d;
}
function f_({ label: a, children: n }) {
  const { collapsed: l } = rt(Tt);
  return /* @__PURE__ */ h("div", { className: Q.group, children: [
    a && !l && /* @__PURE__ */ t("div", { className: Q.groupLabel, children: a }),
    n
  ] });
}
function v_({
  activeId: a,
  onSelect: n,
  collapsed: l = !1,
  onCollapseChange: o,
  collapseLabel: c = "Skjul meny",
  expandLabel: r = "Vis meny",
  bordered: s = !0,
  resizable: _,
  defaultWidth: d = 280,
  minWidth: p = 160,
  maxWidth: u = 500,
  children: i,
  className: g
}) {
  const w = Lt(
    () => ({ activeId: a, collapsed: l, onSelect: n }),
    [a, l, n]
  ), [$, Z] = B(d), [y, E] = B(!1), H = k(null), f = k(null);
  F(() => () => {
    f.current?.();
  }, []);
  function v(M) {
    M.preventDefault(), H.current = { startX: M.clientX, startWidth: $ }, E(!0);
    function b(T) {
      if (!H.current)
        return;
      const D = T.clientX - H.current.startX;
      Z(Math.max(p, Math.min(u, H.current.startWidth + D)));
    }
    function S() {
      H.current = null, E(!1), document.removeEventListener("mousemove", b), document.removeEventListener("mouseup", S), f.current = null;
    }
    f.current = () => {
      document.removeEventListener("mousemove", b), document.removeEventListener("mouseup", S);
    }, document.addEventListener("mousemove", b), document.addEventListener("mouseup", S);
  }
  const m = () => o?.(!l), A = l ? r : c, N = o ? /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      className: `${Q.toggle} ${l ? Q.toggleCollapsed : ""}`,
      onClick: m,
      "aria-label": A,
      "aria-expanded": l ? "false" : "true",
      children: [
        /* @__PURE__ */ t("span", { className: Q.toggleIcon, children: l ? /* @__PURE__ */ t(Ct, { size: 16, "aria-hidden": "true" }) : /* @__PURE__ */ t(Ht, { size: 16, "aria-hidden": "true" }) }),
        !l && /* @__PURE__ */ t("span", { className: Q.toggleLabel, children: A })
      ]
    }
  ) : null;
  return /* @__PURE__ */ t(Tt.Provider, { value: w, children: /* @__PURE__ */ h(
    "nav",
    {
      className: [
        Q.nav,
        l ? Q.navCollapsed : "",
        s ? "" : Q.navBorderless,
        g ?? ""
      ].filter(Boolean).join(" "),
      style: _ && !l ? { width: `${$}px` } : void 0,
      "aria-label": "Sidemeny",
      children: [
        /* @__PURE__ */ t("div", { className: Q.navBody, children: i }),
        N && (l ? /* @__PURE__ */ t(lt, { position: "right", align: "start", content: A, children: N }) : N),
        _ && !l && /* @__PURE__ */ t(
          "div",
          {
            className: `${Q.resizeHandle}${y ? ` ${Q.resizeHandleActive}` : ""}`,
            onMouseDown: v,
            "aria-hidden": "true"
          }
        )
      ]
    }
  ) });
}
const Nd = "Tree-module__tree___RN8OP", wd = "Tree-module__header___a-JEw", yd = "Tree-module__headerLabel___LTi4m", Zd = "Tree-module__items___vdTH9", Md = "Tree-module__itemWrapper___GWa6q", Ld = "Tree-module__row___RYD9D", Hd = "Tree-module__rowToggle___cACKV", Cd = "Tree-module__item___TYtRZ", Sd = "Tree-module__expandBtn___D6ILR", kd = "Tree-module__rowActive___Wp5fE", Td = "Tree-module__caret___Rk9Bk", Id = "Tree-module__caretExpanded___tCnOV", xd = "Tree-module__itemParent___fokw1", Fd = "Tree-module__itemChild___gQ-ES", Bd = "Tree-module__itemLeaf___4F0F5", Dd = "Tree-module__children___hbjjS", Rd = "Tree-module__itemActive___EXblp", Vd = "Tree-module__code___voT0p", Pd = "Tree-module__iconSlot___dtC1c", zd = "Tree-module__label___JSz4p", Od = "Tree-module__meta___o-Ru9", Wd = "Tree-module__badge___LRkrN", Gd = "Tree-module__badgeActive___-JMEd", Ud = "Tree-module__childrenWrap___XXl1c", Yd = "Tree-module__childrenWrapExpanded___x1Vms", Kd = "Tree-module__itemWrapperDragOver___Cetct", z = {
  tree: Nd,
  header: wd,
  headerLabel: yd,
  items: Zd,
  itemWrapper: Md,
  row: Ld,
  rowToggle: Hd,
  item: Cd,
  expandBtn: Sd,
  rowActive: kd,
  caret: Td,
  caretExpanded: Id,
  itemParent: xd,
  itemChild: Fd,
  itemLeaf: Bd,
  children: Dd,
  itemActive: Rd,
  code: Vd,
  iconSlot: Pd,
  label: zd,
  meta: Od,
  badge: Wd,
  badgeActive: Gd,
  childrenWrap: Ud,
  childrenWrapExpanded: Yd,
  itemWrapperDragOver: Kd
}, gn = ot({});
function $_({
  id: a,
  label: n,
  icon: l,
  code: o,
  meta: c,
  count: r,
  children: s,
  defaultExpanded: _ = !1,
  forceExpanded: d,
  dragOver: p,
  dragProps: u
}) {
  const { activeId: i, onSelect: g, expandOnRowClick: w } = rt(gn), [$, Z] = B(_), y = d !== void 0 ? d : $, E = !!s, H = i === a, f = E, v = f && w;
  return /* @__PURE__ */ h(
    "div",
    {
      className: `${z.itemWrapper}${p ? ` ${z.itemWrapperDragOver}` : ""}`,
      role: "treeitem",
      "aria-expanded": E ? y : void 0,
      ...u,
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: `${z.row} ${v ? z.rowToggle : ""} ${v && H ? z.rowActive : ""}`,
            children: [
              E ? /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  className: z.expandBtn,
                  onClick: () => Z((m) => !m),
                  "aria-label": y ? "Lukk" : "Utvid",
                  children: /* @__PURE__ */ t(
                    Ct,
                    {
                      size: 16,
                      weight: "light",
                      className: `${z.caret} ${y ? z.caretExpanded : ""}`
                    }
                  )
                }
              ) : null,
              /* @__PURE__ */ h(
                "button",
                {
                  type: "button",
                  className: `${z.item} ${H ? z.itemActive : ""} ${f ? z.itemParent : z.itemChild} ${E ? "" : z.itemLeaf}`,
                  onClick: () => {
                    v && Z((m) => !m), g?.(a);
                  },
                  "aria-expanded": v ? $ : void 0,
                  "aria-current": H ? "true" : void 0,
                  children: [
                    o && /* @__PURE__ */ t("span", { className: z.code, children: o }),
                    l && /* @__PURE__ */ t("span", { className: z.iconSlot, "aria-hidden": "true", children: l }),
                    /* @__PURE__ */ t("span", { className: z.label, children: n }),
                    c && /* @__PURE__ */ t("span", { className: z.meta, children: c }),
                    r != null && /* @__PURE__ */ t("span", { className: `${z.badge} ${H ? z.badgeActive : ""}`, children: r })
                  ]
                }
              )
            ]
          }
        ),
        E && /* @__PURE__ */ t(
          "div",
          {
            className: `${z.childrenWrap} ${y ? z.childrenWrapExpanded : ""}`,
            children: /* @__PURE__ */ t("div", { className: z.children, role: "group", children: s })
          }
        )
      ]
    }
  );
}
function A_({
  activeId: a,
  onSelect: n,
  label: l,
  headerAction: o,
  children: c,
  className: r,
  expandOnRowClick: s = !1
}) {
  return /* @__PURE__ */ t(gn.Provider, { value: { activeId: a, onSelect: n, expandOnRowClick: s }, children: /* @__PURE__ */ h("div", { className: `${z.tree} ${r ?? ""}`, children: [
    (l || o) && /* @__PURE__ */ h("div", { className: z.header, children: [
      l && /* @__PURE__ */ t("span", { className: z.headerLabel, children: l }),
      o
    ] }),
    /* @__PURE__ */ t("div", { className: z.items, role: "tree", children: c })
  ] }) });
}
function Xd(a) {
  const n = a.trim();
  return /^[a-z][a-z0-9+.-]*:/i.test(n) || n.startsWith("#") || n.startsWith("/") ? n : `https://${n}`;
}
const qd = "RichEditor-module__wrapper___HXDgD", jd = "RichEditor-module__label___jFuNp", Jd = "RichEditor-module__editor___qSZ3O", Qd = "RichEditor-module__toolbar___qnVLU", e2 = "RichEditor-module__toolbarBtn___Y5Zsm", t2 = "RichEditor-module__toolbarBtnActive___XY437", n2 = "RichEditor-module__toolbarDivider___l5qX-", a2 = "RichEditor-module__contenteditable___eJtAI", Ze = {
  wrapper: qd,
  label: jd,
  editor: Jd,
  toolbar: Qd,
  toolbarBtn: e2,
  toolbarBtnActive: t2,
  toolbarDivider: n2,
  contenteditable: a2
}, Vt = [
  { id: "bold", command: "bold", label: "Fet", icon: /* @__PURE__ */ t(nn, { size: 16 }) },
  { id: "italic", command: "italic", label: "Kursiv", icon: /* @__PURE__ */ t(an, { size: 16 }) },
  { id: "underline", command: "underline", label: "Understrek", icon: /* @__PURE__ */ t(ln, { size: 16 }) },
  { id: "div1", divider: !0 },
  { id: "ul", command: "insertUnorderedList", label: "Punktliste", icon: /* @__PURE__ */ t(jt, { size: 16 }) },
  { id: "ol", command: "insertOrderedList", label: "Nummerert liste", icon: /* @__PURE__ */ t(Jt, { size: 16 }) },
  { id: "div2", divider: !0 },
  { id: "link", command: "createLink", label: "Lenke", icon: /* @__PURE__ */ t(qt, { size: 16 }) }
];
function l2() {
  const a = document.getSelection();
  if (!a || a.rangeCount === 0)
    return null;
  const n = a.getRangeAt(0).commonAncestorContainer;
  return (n.nodeType === Node.ELEMENT_NODE ? n : n.parentElement)?.closest("a") ?? null;
}
function o2(a) {
  try {
    return document.queryCommandState(a);
  } catch {
    return !1;
  }
}
function E_({
  label: a,
  value: n,
  onChange: l,
  placeholder: o = "Skriv her…",
  hideLabel: c = !1,
  className: r
}) {
  const s = k(null), [_, d] = B(/* @__PURE__ */ new Set()), p = k(null), u = k(null), [i, g] = B(!1), [w, $] = B(""), Z = k(void 0);
  F(() => {
    s.current && s.current.innerHTML !== n && (s.current.innerHTML = n);
  }, [n]);
  const y = I(() => {
    const b = document.getSelection(), S = s.current;
    if (!b || b.rangeCount === 0 || !S)
      return;
    const T = b.getRangeAt(0);
    S.contains(T.commonAncestorContainer) && (u.current = T.cloneRange());
  }, []), E = I(() => {
    const b = s.current, S = document.getSelection(), T = u.current;
    if (!(!b || !S || !T) && b.contains(T.commonAncestorContainer))
      try {
        S.removeAllRanges(), S.addRange(T);
      } catch {
      }
  }, []), H = I(() => {
    y();
    const b = /* @__PURE__ */ new Set();
    for (const S of Vt)
      "command" in S && o2(S.command) && b.add(S.id);
    d(b);
  }, [y]), f = I(() => {
    s.current && l(s.current.innerHTML), H();
  }, [l, H]), v = I((b) => {
    b.preventDefault();
    const S = b.clipboardData.getData("text/plain");
    if (!S)
      return;
    const D = S.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(/\n{2,}/).map((V) => V.replace(/\n/g, " ").trim()).filter((V) => V.length > 0).join(`

`);
    document.execCommand("insertText", !1, D);
  }, []), m = I((b) => {
    if (!("divider" in b)) {
      if (s.current?.focus(), E(), b.command === "createLink") {
        const S = l2();
        if (S) {
          const T = document.createRange();
          T.selectNodeContents(S), document.getSelection()?.removeAllRanges(), document.getSelection()?.addRange(T);
        }
        y(), $(S?.getAttribute("href") ?? ""), g(!0);
        return;
      }
      document.execCommand(b.command, !1), l(s.current?.innerHTML ?? ""), H();
    }
  }, [E, y, l, H]), A = I(() => {
    Z.current = null, g(!1);
  }, []), N = I(() => {
    Z.current = w.trim(), g(!1);
  }, [w]);
  F(() => {
    if (i)
      return;
    const b = Z.current;
    b !== void 0 && (Z.current = void 0, E(), b && (document.execCommand("createLink", !1, Xd(b)), l(s.current?.innerHTML ?? "")), H());
  }, [i, E, l, H]);
  const M = I((b) => {
    if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(b.key) || !p.current)
      return;
    const T = Array.from(p.current.querySelectorAll("button")), D = T.indexOf(document.activeElement);
    if (D === -1)
      return;
    b.preventDefault();
    let V = D;
    b.key === "ArrowRight" && (V = (D + 1) % T.length), b.key === "ArrowLeft" && (V = (D - 1 + T.length) % T.length), b.key === "Home" && (V = 0), b.key === "End" && (V = T.length - 1), T[V].focus();
  }, []);
  return /* @__PURE__ */ h("div", { className: `${Ze.wrapper} ${r ?? ""}`, children: [
    a && /* @__PURE__ */ t("label", { className: `${Ze.label} ${c ? "sr-only" : ""}`, children: a }),
    /* @__PURE__ */ h("div", { className: Ze.editor, children: [
      /* @__PURE__ */ t("div", { ref: p, className: Ze.toolbar, role: "toolbar", "aria-label": "Formateringsverktøy", onKeyDown: M, children: Vt.map(
        (b) => "divider" in b ? /* @__PURE__ */ t("span", { className: Ze.toolbarDivider, "aria-hidden": "true" }, b.id) : /* @__PURE__ */ t(lt, { content: b.label, children: /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: `${Ze.toolbarBtn} ${_.has(b.id) ? Ze.toolbarBtnActive : ""}`,
            "aria-label": b.label,
            "aria-pressed": _.has(b.id),
            onMouseDown: (S) => S.preventDefault(),
            onClick: () => m(b),
            children: b.icon
          }
        ) }, b.id)
      ) }),
      /* @__PURE__ */ t(
        "div",
        {
          ref: s,
          className: Ze.contenteditable,
          contentEditable: !0,
          suppressContentEditableWarning: !0,
          role: "textbox",
          "aria-multiline": "true",
          "aria-label": a ?? "Teksteditor",
          "data-placeholder": o,
          onInput: f,
          onPaste: v,
          onKeyUp: H,
          onMouseUp: H,
          onBlur: y
        }
      )
    ] }),
    /* @__PURE__ */ t(
      ds,
      {
        open: i,
        onClose: A,
        title: "Lenke",
        returnFocusRef: s,
        footer: /* @__PURE__ */ h(ge, { children: [
          /* @__PURE__ */ t(yt, { variant: "secondary", onClick: A, children: "Avbryt" }),
          /* @__PURE__ */ t(yt, { onClick: N, disabled: !w.trim(), children: "Sett inn lenke" })
        ] }),
        children: /* @__PURE__ */ t(
          kt,
          {
            label: "URL",
            type: "url",
            value: w,
            onChange: (b) => $(b.target.value),
            onKeyDown: (b) => {
              b.key === "Enter" && (b.preventDefault(), w.trim() && N());
            },
            placeholder: "https://",
            autoFocus: !0
          }
        )
      }
    )
  ] });
}
const r2 = "DropZone-module__wrapper___2W-Ax", c2 = "DropZone-module__label___ew6UZ", s2 = "DropZone-module__zone___bgIev", i2 = "DropZone-module__zoneDragOver___k4MYf", d2 = "DropZone-module__zoneIcon___nFMM6", _2 = "DropZone-module__zoneTitle___xIBUv", u2 = "DropZone-module__zoneHint___57P38", m2 = "DropZone-module__grid___QHZy9", p2 = "DropZone-module__thumb___buZTo", h2 = "DropZone-module__thumbPreview___MI5-S", g2 = "DropZone-module__thumbImg___TzMOk", b2 = "DropZone-module__thumbMeta___eIF-L", f2 = "DropZone-module__thumbName___firGT", v2 = "DropZone-module__thumbRemove___tuEEK", ae = {
  wrapper: r2,
  label: c2,
  zone: s2,
  zoneDragOver: i2,
  zoneIcon: d2,
  zoneTitle: _2,
  zoneHint: u2,
  grid: m2,
  thumb: p2,
  thumbPreview: h2,
  thumbImg: g2,
  thumbMeta: b2,
  thumbName: f2,
  thumbRemove: v2
};
function N_({
  label: a,
  onFiles: n,
  files: l = [],
  onRemove: o,
  accept: c = "image/*",
  multiple: r = !0,
  title: s = "Slipp filer her, eller klikk for å laste opp",
  hint: _ = "PNG, JPG eller SVG. Maks 5 MB per fil.",
  hideLabel: d = !1,
  className: p
}) {
  const u = k(null), [i, g] = B(!1), w = Y(), $ = `${w}-file`, Z = `${w}-label`, y = `${w}-title`, E = `${w}-hint`, H = a ? `${Z} ${y}` : y, f = () => u.current?.click(), v = (M) => {
    M.target.files && (n?.(Array.from(M.target.files)), M.target.value = "");
  }, m = I((M) => {
    M.preventDefault(), g(!0);
  }, []), A = I(() => {
    g(!1);
  }, []), N = I(
    (M) => {
      M.preventDefault(), g(!1), M.dataTransfer.files.length > 0 && n?.(Array.from(M.dataTransfer.files));
    },
    [n]
  );
  return /* @__PURE__ */ h("div", { className: `${ae.wrapper} ${p ?? ""}`, children: [
    a && /* @__PURE__ */ t(
      "label",
      {
        id: Z,
        htmlFor: $,
        className: `${ae.label} ${d ? "sr-only" : ""}`,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      "input",
      {
        ref: u,
        id: $,
        type: "file",
        accept: c,
        multiple: r,
        style: { display: "none" },
        onChange: v
      }
    ),
    l.length > 0 && /* @__PURE__ */ t("div", { className: ae.grid, children: l.map((M) => /* @__PURE__ */ h("div", { className: ae.thumb, children: [
      /* @__PURE__ */ t("div", { className: ae.thumbPreview, children: M.previewUrl ? /* @__PURE__ */ t("img", { src: M.previewUrl, alt: M.name, className: ae.thumbImg }) : /* @__PURE__ */ t(Kt, { size: 24 }) }),
      /* @__PURE__ */ h("div", { className: ae.thumbMeta, children: [
        /* @__PURE__ */ t("span", { className: ae.thumbName, children: M.name }),
        o && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: ae.thumbRemove,
            onClick: () => o(M.name),
            "aria-label": `Fjern ${M.name}`,
            children: /* @__PURE__ */ t(de, { size: 12 })
          }
        )
      ] })
    ] }, M.name)) }),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        className: `${ae.zone} ${i ? ae.zoneDragOver : ""}`,
        "aria-labelledby": H,
        "aria-describedby": E,
        onClick: f,
        onDragOver: m,
        onDragLeave: A,
        onDrop: N,
        children: [
          /* @__PURE__ */ t(Ut, { size: 28, weight: "thin", className: ae.zoneIcon, "aria-hidden": "true" }),
          /* @__PURE__ */ t("span", { id: y, className: ae.zoneTitle, children: s }),
          /* @__PURE__ */ t("span", { id: E, className: ae.zoneHint, children: _ })
        ]
      }
    )
  ] });
}
const $2 = "SortableList-module__list___ewfYB", A2 = "SortableList-module__item___1ez1d", E2 = "SortableList-module__row___A5RbG", N2 = "SortableList-module__itemLocked___ADcam", w2 = "SortableList-module__itemPinned___yaOFf", y2 = "SortableList-module__dragStatic___Crd3H", Z2 = "SortableList-module__iconTooltip___rR9ef", M2 = "SortableList-module__itemDragging___Th-Dt", L2 = "SortableList-module__actions___ECgur", H2 = "SortableList-module__drag___HLHIj", C2 = "SortableList-module__body___zPHBr", S2 = "SortableList-module__titleRow___FInlK", k2 = "SortableList-module__title___bMqkA", T2 = "SortableList-module__indexNumber___zNNwO", I2 = "SortableList-module__content___uRePD", x2 = "SortableList-module__contentSeparator___g5wvi", U = {
  list: $2,
  item: A2,
  row: E2,
  itemLocked: N2,
  itemPinned: w2,
  dragStatic: y2,
  iconTooltip: Z2,
  itemDragging: M2,
  actions: L2,
  drag: H2,
  body: C2,
  titleRow: S2,
  title: k2,
  indexNumber: T2,
  content: I2,
  contentSeparator: x2
}, We = 60, Pt = 14;
function F2(a) {
  let n = a?.parentElement ?? null;
  for (; n; ) {
    const o = getComputedStyle(n).overflowY;
    if ((o === "auto" || o === "scroll") && n.scrollHeight > n.clientHeight)
      return n;
    n = n.parentElement;
  }
  return null;
}
function w_({ count: a, onReorder: n }) {
  const [l, o] = B({ dragIndex: null, overIndex: null }), c = k([]), r = k(0), s = k(0), _ = k(0), d = k(0), p = k(null), u = k(null), i = k(null), g = k(null), w = k(n);
  w.current = n;
  const $ = k(a);
  $.current = a;
  const Z = I(() => {
    if (p.current == null || d.current === 0)
      return;
    const v = i.current ? i.current.scrollTop - s.current : 0, m = _.current - r.current + v, A = Math.round(m / d.current), N = Math.max(0, Math.min($.current - 1, p.current + A));
    N !== u.current && (u.current = N, o({ dragIndex: p.current, overIndex: N }));
  }, []), y = I(() => {
    g.current != null && (cancelAnimationFrame(g.current), g.current = null);
  }, []), E = I(() => {
    const v = i.current;
    if (!v || p.current == null) {
      g.current = null;
      return;
    }
    const m = v.getBoundingClientRect();
    let A = 0;
    const N = _.current - m.top, M = m.bottom - _.current;
    if (N < We && v.scrollTop > 0) {
      const b = Math.min(1, (We - N) / We);
      A = -Math.max(1, b * Pt);
    } else if (M < We && v.scrollTop < v.scrollHeight - v.clientHeight) {
      const b = Math.min(1, (We - M) / We);
      A = Math.max(1, b * Pt);
    }
    A !== 0 && (v.scrollTop += A, Z()), g.current = requestAnimationFrame(E);
  }, [Z]), H = I((v) => ({
    onPointerDown: (m) => {
      const A = m.currentTarget;
      A.setPointerCapture(m.pointerId);
      const N = c.current[v];
      N && (d.current = N.getBoundingClientRect().height + parseFloat(getComputedStyle(N.parentElement).gap || "0"));
      const M = F2(N);
      i.current = M, s.current = M?.scrollTop ?? 0, r.current = m.clientY, _.current = m.clientY, p.current = v, u.current = v, o({ dragIndex: v, overIndex: v }), g.current == null && M && (g.current = requestAnimationFrame(E));
      function b(T) {
        _.current = T.clientY, Z();
      }
      function S() {
        A.removeEventListener("pointermove", b), A.removeEventListener("pointerup", S), A.removeEventListener("pointercancel", S), y();
        const T = p.current, D = u.current;
        p.current = null, u.current = null, i.current = null, o({ dragIndex: null, overIndex: null }), T != null && D != null && T !== D && w.current(T, D);
      }
      A.addEventListener("pointermove", b), A.addEventListener("pointerup", S), A.addEventListener("pointercancel", S);
    },
    role: "button",
    tabIndex: 0,
    "aria-roledescription": "sorterbart element",
    onKeyDown: (m) => {
      m.key === "ArrowUp" && v > 0 ? (m.preventDefault(), w.current(v, v - 1)) : m.key === "ArrowDown" && v < $.current - 1 && (m.preventDefault(), w.current(v, v + 1));
    }
  }), [E, Z, y]), f = I((v) => {
    let m = 0;
    const { dragIndex: A, overIndex: N } = l;
    A != null && N != null && A !== N && (v === A ? m = (N - A) * d.current : A < N && v > A && v <= N ? m = -d.current : A > N && v >= N && v < A && (m = d.current));
    const M = A === v;
    return {
      ref: (b) => {
        c.current[v] = b;
      },
      style: {
        transform: m !== 0 ? `translateY(${m}px)` : void 0,
        transition: M ? "none" : "transform 150ms ease",
        zIndex: M ? 10 : void 0,
        position: "relative"
      }
    };
  }, [l]);
  return { state: l, getDragHandleProps: H, getItemProps: f };
}
const y_ = R(
  function({
    index: n,
    icon: l,
    title: o,
    description: c,
    meta: r,
    footer: s,
    actions: _,
    dragHandleProps: d,
    isDragging: p,
    showIndex: u = !1,
    locked: i = !1,
    lockedLabel: g = "Låst — kan ikke flyttes eller redigeres på dette nivået",
    pinPosition: w,
    pinLabel: $,
    children: Z,
    expanded: y,
    defaultExpanded: E = !1,
    onExpandedChange: H
  }, f) {
    const [v, m] = B(E), A = y !== void 0, N = A ? y : v, M = Y(), b = !!Z, S = w !== void 0, T = S ? `Dra for å flytte «${o}» innen ${w === "top" ? "topp-" : "bunn-"}gruppen` : `Dra for å flytte «${o}»`;
    function D() {
      const K = !N;
      A || m(K), H?.(K);
    }
    const V = !i && d !== void 0, te = !i && S && !V, le = $ ?? (w === "top" ? "Festet til toppen — kan ikke flyttes opp eller ned" : "Festet til bunnen — kan ikke flyttes opp eller ned"), _e = [
      U.item,
      p && U.itemDragging,
      N && U.itemExpanded,
      i && U.itemLocked,
      S && U.itemPinned
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ h(
      "li",
      {
        ref: f,
        className: _e,
        "data-locked": i || void 0,
        children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: U.row,
              onClick: (K) => {
                !b || K.target.closest("button, a, input, [role='menuitem'], [role='switch']") || D();
              },
              style: b ? { cursor: "pointer" } : void 0,
              children: [
                i && /* @__PURE__ */ t(lt, { content: g, position: "top", className: U.iconTooltip, children: /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: `${U.drag} ${U.dragStatic}`,
                    "aria-label": g,
                    "aria-disabled": "true",
                    onClick: (K) => K.preventDefault(),
                    children: /* @__PURE__ */ t(Qt, { size: 16, "aria-hidden": "true" })
                  }
                ) }),
                te && /* @__PURE__ */ t(lt, { content: le, position: "top", className: U.iconTooltip, children: /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: `${U.drag} ${U.dragStatic}`,
                    "aria-label": le,
                    "aria-disabled": "true",
                    onClick: (K) => K.preventDefault(),
                    children: /* @__PURE__ */ t(
                      tn,
                      {
                        size: 16,
                        "aria-hidden": "true",
                        style: w === "bottom" ? { transform: "rotate(180deg)" } : void 0
                      }
                    )
                  }
                ) }),
                V && /* @__PURE__ */ t(
                  "button",
                  {
                    ...d,
                    type: "button",
                    className: U.drag,
                    "aria-label": T,
                    children: /* @__PURE__ */ t(Yt, { size: 16, "aria-hidden": "true" })
                  }
                ),
                /* @__PURE__ */ h("div", { className: U.body, children: [
                  /* @__PURE__ */ h("div", { className: U.titleRow, children: [
                    l && /* @__PURE__ */ t("span", { className: U.icon, children: l }),
                    u && /* @__PURE__ */ t("span", { className: U.indexNumber, "aria-hidden": "true", children: n }),
                    /* @__PURE__ */ t("span", { className: U.title, children: o }),
                    r
                  ] }),
                  c && /* @__PURE__ */ t("p", { className: U.desc, children: c }),
                  s
                ] }),
                _ && /* @__PURE__ */ t("div", { className: U.actions, children: _ }),
                b && /* @__PURE__ */ t(
                  sn,
                  {
                    icon: N ? /* @__PURE__ */ t(St, { size: 16 }) : /* @__PURE__ */ t(Ue, { size: 16 }),
                    label: N ? "Lukk" : "Åpne",
                    size: "sm",
                    variant: "outline",
                    onClick: D,
                    "aria-expanded": N,
                    "aria-controls": M
                  }
                )
              ]
            }
          ),
          b && N && /* @__PURE__ */ h("div", { id: M, className: U.content, children: [
            /* @__PURE__ */ t("div", { className: U.contentSeparator, "aria-hidden": "true" }),
            Z
          ] })
        ]
      }
    );
  }
);
function Z_({ children: a, className: n }) {
  return /* @__PURE__ */ t("ul", { className: `${U.list} ${n ?? ""}`, children: a });
}
export {
  O2 as Accordion,
  W2 as ActionBar,
  G2 as ActionGroup,
  c_ as Alert,
  h_ as AppHeader,
  V2 as AppShell,
  Qo as Avatar,
  U2 as BackButton,
  rc as Banner,
  z2 as Block,
  xs as BottomSheet,
  yt as Button,
  co as Card,
  n_ as CardContent,
  a_ as CardFooter,
  t_ as CardHeader,
  wt as Checkbox,
  Vo as Chip,
  Ni as ColorPicker,
  u0 as Combobox,
  r_ as DataTable,
  Ll as DateInput,
  ds as Dialog,
  N_ as DropZone,
  m_ as Dropdown,
  pn as EmptyState,
  Go as FilterChipGroup,
  Y2 as FilterPanel,
  sn as IconButton,
  K1 as List,
  l_ as ListCard,
  no as ListItem,
  s_ as Loader,
  hc as Notice,
  $l as NumberInput,
  g_ as PageHeader,
  yr as Pagination,
  pa as Panel,
  p_ as Popover,
  E0 as RadioGroup,
  E_ as RichEditor,
  cl as SearchInput,
  Co as SearchResultCard,
  q2 as SegmentedControl,
  Rl as Select,
  X2 as SelectableCard,
  K2 as SelectableCardGroup,
  u_ as Sheet,
  P2 as ShellPanel,
  v_ as SideNav,
  f_ as SideNavGroup,
  b_ as SideNavItem,
  d_ as SkeletonCard,
  i_ as SkeletonLine,
  Ci as Slider,
  y_ as SortableItem,
  Z_ as SortableList,
  o_ as StatusDot,
  G0 as Switch,
  j2 as TabBar,
  _n as Table,
  mn as TableBody,
  nt as TableCell,
  un as TableHead,
  Zt as TableHeaderCell,
  ht as TableRow,
  Ml as TextArea,
  kt as TextInput,
  es as ToastProvider,
  J2 as Toolbar,
  e_ as ToolbarDivider,
  Q2 as ToolbarGroup,
  D1 as ToolbarItem,
  lt as Tooltip,
  A_ as Tree,
  $_ as TreeItem,
  Xd as normalizeUrl,
  w_ as useSortable,
  __ as useToast
};
//# sourceMappingURL=index.mjs.map
